export const ServiceCategoryInfo = {
    general: {
        title: 'PRISTINE SMILE CLEANING & DENTAL EXAM',
        tagline: 'Keep your smile healthy',
        serviceInfo: {
            title: 'Innovative Care, Designed for You',
            description: 'We’re redefining the dental experience with modern technology, personalized treatments, and a comfort-first approach. Whether you need a simple cleaning or a full smile makeover, we ensure every visit is seamless, effective, and stress-free.',
            points: [
                'Advanced Digital Dentistry – 3D imaging, laser treatments, and AI-assisted diagnostics for precision care.',
                'Same-Day Appointments – Quick, efficient care when you need it most.',
                'Minimally Invasive Treatments – Cutting-edge techniques for faster healing and pain-free procedures.',
                'Personalized Smile Plans – Custom treatment options tailored to your unique dental goals.',
                'Relaxing Patient Experience – Enjoy soothing amenities, entertainment, and a warm, welcoming environment.',
                'Comprehensive Family Care – From toddlers to seniors, we make dentistry easy and comfortable for every age.'
            ],
            tagline: `
            We’re not just about fixing teeth—we’re about creating confidence, enhancing smiles, and making every visit a positive experience.
            🚀 Discover a new standard in dental care—schedule your visit today!
          `
        },
        services: [{
            service: 'Cleanings & Exams',
            description: 'Keep your teeth healthy with regular professional cleanings and thorough dental exams.'
        }, {
            service: 'Emergency Care',
            description: 'Quick, reliable care when you need it most—relief for toothaches, broken teeth, and urgent dental issues.'
        }, {
            service: 'Crowns',
            description: 'Restore strength and beauty to damaged teeth with durable, natural-looking dental crowns.'
        }, {
            service: 'Gum Therapy',
            description: 'Protect your gums and prevent gum disease with specialized treatments for a healthier smile.'
        }, {
            service: 'Dental Fillings',
            description: 'Repair cavities and restore your teeth with strong, long-lasting fillings that blend seamlessly.'
        }, {
            service: 'Dentures',
            description: 'Comfortable, custom-fit dentures to restore your smile and improve your ability to eat and speak.'
        }, {
            service: 'Night Guards',
            description: 'Protect your teeth from grinding and clenching with custom-made night guards for better sleep.'
        }, {
            service: 'Family Dentistry',
            description: 'Comprehensive dental care for all ages, ensuring healthy smiles for your whole family.'
        }],
        faqs: [
            {
                question: "How often should I get a dental cleaning?",
                answer: "We recommend getting a professional dental cleaning and exam every six months to maintain optimal oral health and catch potential issues early."
            },
            {
                question: "Is dental treatment painful?",
                answer: "Most general dental treatments are minimally invasive and performed with comfort in mind. We use gentle techniques and offer local anesthesia or sedation when needed."
            },
            {
                question: "Do I need an exam if I’m not experiencing pain?",
                answer: "Yes. Many dental issues, such as cavities or gum disease, can develop without noticeable symptoms. Regular exams help detect problems early."
            },
            {
                question: "Can I bring my children for checkups too?",
                answer: "Absolutely! Our family dentistry services are designed for patients of all ages, and we create a friendly, fun environment for kids."
            },
            {
                question: "What should I do during a dental emergency?",
                answer: "Call us immediately. We offer same-day emergency appointments and will guide you through what to do until you arrive at our office."
            }
        ]
    }, cosmetic: {
        title: 'PRISTINE SMILE FILLING',
        tagline: 'Keep your smile healthy',
        serviceInfo: {
            title: 'Transform Your Smile with Cosmetic Dentistry',
            description: 'Your smile is your signature, and we’re here to make it brighter, straighter, and more confident than ever. Our advanced cosmetic dentistry services are designed to enhance your natural beauty while ensuring a healthy, radiant smile.',
            points: [
                'Invisibly Perfect – Straighten teeth discreetly with Invisalign for a seamless transformation.',
                'Youthful, Radiant Look – Botox treatments smooth fine lines while enhancing your smile’s aesthetics.',
                'Whiter, Brighter Smiles – Say goodbye to stains with professional teeth whitening that delivers instant results.',
                'Flawless Finishes – From bonding to veneers, we perfect your smile with natural, long-lasting enhancements.',
                'Fully Customized Makeovers – A personalized smile makeover combining multiple treatments for your dream look.',
                'Minimally Invasive, Maximum Impact – We use the latest techniques to ensure comfort, durability, and stunning results.'
            ],
            tagline: `Cosmetic dentistry isn’t just about looks—it’s about confidence, self-expression, and feeling great every day. 🚀 Ready to shine? Book your consultation today and let’s design your perfect smile!`
        },
        services: [{
            service: 'Invisalign',
            description: 'Straighten your teeth discreetly with clear, comfortable, and removable aligners.'
        }, {
            service: 'Teeth Whitening',
            description: 'Brighten your smile with professional in-office or take-home whitening treatments.'
        }, {
            service: 'Bonding',
            description: 'Fix chips, gaps, and discoloration with quick, natural-looking dental bonding.'
        }, {
            service: 'Veneers',
            description: 'Transform your smile with custom-crafted, ultra-thin porcelain veneers.'
        }, {
            service: 'Smile Makeover',
            description: 'A customized combination of cosmetic treatments to create your perfect smile.'
        }],
        faqs: [
            {
                question: "What’s the best way to whiten my teeth?",
                answer: "We offer both in-office and take-home professional whitening solutions. They’re more effective and safer than over-the-counter products."
            },
            {
                question: "How long do veneers last?",
                answer: "With proper care, veneers can last 10–15 years or longer. Regular checkups and good oral hygiene are key to longevity."
            },
            {
                question: "Is Invisalign better than braces?",
                answer: "Invisalign is a discreet, comfortable option for mild to moderate alignment issues. We’ll assess your smile to recommend the best option for you."
            },
            {
                question: "Can cosmetic dentistry fix chipped or uneven teeth?",
                answer: "Yes! Options like bonding, veneers, and crowns can restore your smile’s shape, symmetry, and brightness."
            },
            {
                question: "Will my smile still look natural after cosmetic treatment?",
                answer: "Absolutely. We customize all cosmetic treatments to enhance your natural beauty while preserving a realistic, balanced appearance."
            }
        ]
    }, surgical: {
        title: 'PRISTINE SMILE ROOT CANAL',
        tagline: 'Keep your smile healthy',
        serviceInfo: {
            title: 'Expert Surgical Dentistry for a Stronger, Healthier Smile',
            description: 'Whether you need a simple extraction or a full-mouth restoration, our surgical dentistry services are designed to restore function, improve aesthetics, and enhance your oral health with precision and care. We use the latest technology and minimally invasive techniques to ensure comfort, quick healing, and long-lasting results.',
            points: [
                'State-of-the-Art Implants – Replace missing teeth permanently with strong, natural-looking implants.',
                'Gentle Extractions – Safe and stress-free tooth removal for problematic or damaged teeth.',
                'Pain-Free Root Canals – Preserve your natural teeth with expert root canal treatments for lasting relief.',
                'Jawbone Restoration – Strengthen bone structure with bone grafts to support implants and overall oral health.',
                'Secure & Stable Dentures – Enjoy superior comfort with implant-supported dentures for a natural feel.',
                'Bridge the Gaps – Dental bridges offer a seamless, durable solution to restore missing teeth.'
            ],
            tagline: `
            From single-tooth repairs to full-mouth reconstructions, we provide exceptional care with advanced solutions to give you a strong, functional, and confident smile.
            🚀 Schedule your consultation today and take the first step toward lasting oral health!
          `
        },
        services: [{
            service: 'Implants',
            description: 'Permanently replace missing teeth with strong, natural-looking dental implants.'
        }, {
            service: 'Extractions',
            description: 'Safe and gentle tooth removal for damaged or problematic teeth.'
        }, {
            service: 'Root Canal',
            description: 'Relieve pain and save your natural tooth with expert root canal treatment.'
        }, {
            service: 'Bone Grafts',
            description: 'Strengthen your jawbone for implants or overall dental health.'
        }, {
            service: 'Implant-Supported Dentures',
            description: 'A secure, comfortable alternative to traditional dentures for a confident smile.'
        }, {
            service: 'Bridges',
            description: 'Restore missing teeth with durable, natural-looking dental bridges.'
        }],
        faqs: [
            {
                question: "Is a tooth extraction painful?",
                answer: "Not at all. We use local anesthesia and gentle techniques to ensure a comfortable experience. Post-op care instructions help with healing."
            },
            {
                question: "How long does it take to recover after implant surgery?",
                answer: "Initial healing takes a few days, but full integration with the jawbone (osseointegration) takes a few months. We'll guide you every step of the way."
            },
            {
                question: "Do I need a bone graft before getting implants?",
                answer: "If your jawbone lacks density or volume, a bone graft may be necessary to ensure the success of your dental implant."
            },
            {
                question: "How long do dental implants last?",
                answer: "With proper care, dental implants can last a lifetime. Regular checkups and good oral hygiene are essential."
            },
            {
                question: "What’s the difference between a crown and a bridge?",
                answer: "A crown covers a damaged tooth, while a bridge replaces one or more missing teeth using crowns as anchors. We’ll help determine which suits your needs."
            }
        ]
    }, other: {
        title: 'PRISTINE SMILE VANEER',
        tagline: 'Keep your smile healthy',
        serviceInfo: {
            title: 'Comprehensive Dental Solutions for Every Need',
            description: 'From minor concerns to complex dental issues, we offer a wide range of treatments to ensure your smile stays healthy, strong, and beautiful. Whether it’s restoring damaged teeth, relieving pain, or enhancing your appearance, we provide customized, patient-focused solutions to meet your unique dental needs.',
            points: [
                'Fix Chips & Cracks – Repair chipped or cracked teeth seamlessly with bonding, veneers, or crowns.',
                'Wisdom Tooth Relief – Get expert evaluation and treatment for wisdom tooth pain and discomfort.',
                'Replace Missing Teeth – Restore your natural look and function with implants, bridges, or dentures.',
                'Preventive Care – Maintain strong, cavity-free teeth with routine checkups and personalized tooth care.',
                'Teeth Grinding Protection – Safeguard your smile with custom night guards and grinding solutions.',
                'Brighter, Whiter Teeth – Get rid of stains with professional whitening and stain removal treatments.',
                'Straighter Smiles – Correct crooked teeth with Invisalign and other orthodontic solutions.',
                'Healthy Gums – Prevent and treat bleeding gums with professional cleanings and gum therapy.',
                'Fresh Breath Confidence – Tackle bad breath at its source with expert cleanings and oral care guidance.'
            ],
            tagline: `
            No matter your dental concern, we provide advanced, effective treatments to keep your smile at its best.
            🚀 Book your appointment today and let’s take care of your smile together!
          `
        },
        services: [{
            service: 'Chipped or Cracked Teeth',
            description: 'Repair damaged teeth with bonding, veneers, or crowns for a seamless smile.'
        }, {
            service: 'Wisdom Tooth Pain',
            description: 'Get relief from impacted or painful wisdom teeth with expert evaluation and treatment.'
        }, {
            service: 'Missing Tooth',
            description: 'Restore your smile with implants, bridges, or dentures for a natural look and feel.'
        }, {
            service: 'Toothcare',
            description: 'Comprehensive preventive care to keep your teeth strong, healthy, and cavity-free.'
        }, {
            service: 'Teeth Grinding',
            description: 'Protect your teeth from grinding damage with custom night guards and treatment options.'
        }, {
            service: 'Stained Teeth',
            description: 'Brighten your smile with professional teeth whitening and stain removal treatments.'
        }, {
            service: 'Crooked Teeth',
            description: 'Straighten your smile with Invisalign or orthodontic treatments tailored to your needs.'
        }, {
            service: 'Bleeding Gums',
            description: 'Treat and prevent gum disease with professional cleanings and gum therapy.'
        }, {
            service: 'Bad Breath',
            description: 'Address the root cause of bad breath with professional cleanings and personalized oral care tips.'
        }],
        faqs: [
            {
                question: "What should I do if I chip or crack a tooth?",
                answer: "Contact us right away. We offer same-day emergency care and have multiple solutions like bonding or crowns to restore the tooth quickly and comfortably."
            },
            {
                question: "Why do my gums bleed when brushing?",
                answer: "Bleeding gums can be a sign of gum disease. We recommend scheduling a cleaning and evaluation to prevent further issues."
            },
            {
                question: "What causes bad breath, and how can I fix it?",
                answer: "Persistent bad breath is often linked to bacteria buildup or gum disease. Professional cleanings, good hygiene, and targeted treatments can help."
            },
            {
                question: "Can grinding my teeth really cause damage?",
                answer: "Yes. Chronic grinding can lead to enamel wear, jaw pain, and cracked teeth. We offer custom night guards to protect your smile."
            },
            {
                question: "Do you treat wisdom tooth pain?",
                answer: "Absolutely. We evaluate your wisdom teeth with X-rays and recommend the right course of action, including extraction if necessary."
            }
        ]
    }
}

export const ServiceDetail = {
    cleaning_exams: {
        title: 'Professional Cleanings & Exams',
        tagline: 'Keep Your Smile Healthy & Bright!',
        overview: 'Routine dental cleanings and exams are the foundation of a healthy smile. Regular visits help prevent cavities, gum disease, and other dental issues before they become major problems. Our professional cleanings remove plaque and tartar buildup, while comprehensive exams ensure early detection of potential concerns—keeping your smile in top shape!',
        benefits: [
            '✅ Prevents cavities, gum disease, and enamel wear',
            '✅ Removes plaque and tartar buildup for a fresh, clean feel',
            '✅ Early detection of dental issues to avoid costly treatments',
            '✅ Improves overall oral health and hygiene',
            '✅ Provides a brighter, whiter, and healthier smile'
        ],
        symptoms: [
            '✔ Noticeable plaque or tartar buildup',
            '✔ Bleeding or swollen gums when brushing or flossing',
            '✔ Persistent bad breath despite regular brushing',
            '✔ Tooth sensitivity to hot or cold',
            '✔ Haven’t had a dental check-up in 6+ months'
        ],
        treatment: [
            '1️⃣ Comprehensive Exam – We assess your teeth, gums, and oral health to identify any issues.',
            '2️⃣ 3D X-Rays (Once a Year) – Advanced imaging to detect cavities, bone loss, or hidden dental concerns.',
            '3️⃣ Professional Cleaning – Your hygienist will remove plaque, tartar, and surface stains for a polished finish.',
            '4️⃣ Gum Health Check – We evaluate your gums for signs of inflammation or early gum disease.',
            '5️⃣ Personalized Oral Care Plan – Our dentist will discuss recommendations and preventative measures for long-term health.'
        ],
        aftercare: [
            'Maintain a consistent brushing and flossing routine at home',
            'Use fluoride toothpaste to strengthen enamel and prevent cavities',
            'Avoid excessive sugar and acidic foods that contribute to decay',
            'Drink plenty of water to wash away bacteria and maintain oral health',
            'Schedule cleanings every 6 months for continued care and prevention'
        ],
        faq: [{
            question: 'How often should I get a dental cleaning?',
            answer: 'It’s recommended to get a professional cleaning and exam every six months to maintain optimal oral health.'
        }, {
            question: 'Does a dental cleaning hurt?',
            answer: 'Not at all! Cleanings are gentle and pain-free. Some mild sensitivity may occur if there’s heavy plaque buildup, but our team ensures your comfort.'
        }, {
            question: 'What happens if I skip my dental cleanings?',
            answer: 'Skipping cleanings allows plaque and tartar to build up, increasing the risk of cavities, gum disease, and bad breath. Regular cleanings prevent these issues.'
        }, {
            question: 'Are X-rays necessary for routine exams?',
            answer: 'Yes! X-rays help detect hidden cavities, bone loss, and other issues not visible during a regular exam, ensuring early treatment.'
        }],
        beforeandafter: [],
        testimonials: [
            'Dr. Aesha patiently explained my treatment options and answered all my questions, making me feel comfortable during  my treatment. It was the most comfortable treatment I have ever had. I am very happy with the results. Very hygienic clinic. 💯% recommended.👍 -- Nehal Patel',
            'Amazing experience with Pristine Smile, Dr Aesha has Great Hands on experience, knowledge and Apt facilities to restore your smile, pristine way. Mahi, supporting staff is also very helpful and soft spoken. Continuous chanting makes the environment divine. Highly appreciated and recommended. -- Yatin Baxi'
        ],
        relatedservices: [
            {
                detail: 'Gum Therapy – Maintain strong, healthy gums and prevent gum disease',
                link: '/gum_therapy'
            },
            {
                detail: 'Teeth Whitening – Enhance your clean smile with professional whitening',
                link: '/teeth_whitening'
            },
            {
                detail: 'Family Dentistry – Dental care for every member of the family',
                link: '/family_dentistry'
            }
        ]

    }, emergency_care: {
        title: 'Emergency Dental Care',
        tagline: 'Immediate Relief When You Need It Most!',
        overview: 'Dental emergencies can happen anytime, and quick action is key to preventing further damage or discomfort. Whether it’s a severe toothache, a broken tooth, or a knocked-out tooth, our emergency dental care team is here to provide immediate, effective treatment to relieve pain and restore your smile.',
        benefits: [
            '✅ Immediate pain relief and treatment',
            '✅ Prevents further damage or infections',
            '✅ Quick and efficient solutions to dental emergencies',
            '✅ Same-day appointments available for urgent cases',
            '✅ Expert care to restore your smile and oral health'
        ],
        symptoms: [
            '✔ Severe, persistent tooth pain or sensitivity',
            '✔ Chipped, cracked, or broken teeth',
            '✔ Knocked-out or loose teeth due to trauma',
            '✔ Swollen gums, abscess, or signs of infection',
            '✔ Bleeding from the mouth that won’t stop'
        ],
        treatment: [
            '1️⃣ Immediate Evaluation – We assess your condition and take necessary X-rays to determine the issue.',
            '2️⃣ Pain Management – We provide treatment to relieve pain quickly and safely.',
            '3️⃣ Tooth Repair or Extraction – Depending on the severity, we restore or extract the damaged tooth.',
            '4️⃣ Infection Control – If necessary, we prescribe antibiotics and recommend follow-up care.',
            '5️⃣ Preventive Guidance – We provide instructions on how to prevent future emergencies and maintain oral health.'
        ],
        aftercare: [
            'Follow post-treatment care instructions provided by your dentist',
            'Avoid chewing hard foods on the affected area',
            'Take prescribed pain relievers or antibiotics as directed',
            'Maintain good oral hygiene to prevent further issues',
            'Schedule follow-up visits if needed for continued care'
        ],
        faq: [{
            question: 'What qualifies as a dental emergency?',
            answer: 'Severe tooth pain, knocked-out teeth, broken teeth, excessive bleeding, and infections that cause swelling or difficulty breathing should be treated immediately.'
        }, {
            question: 'Can I go to the ER for a dental emergency?',
            answer: 'Hospital ERs can provide pain relief but usually do not perform dental procedures. It’s best to visit an emergency dentist for immediate treatment.'
        }, {
            question: 'What should I do if I knock out a tooth?',
            answer: 'Keep the tooth moist by placing it in milk or saliva and get to a dentist immediately—there’s a higher chance of saving the tooth within an hour of injury.'
        }, {
            question: 'How can I prevent dental emergencies?',
            answer: 'Wear a mouthguard during sports, avoid biting hard objects, maintain regular dental visits, and practice good oral hygiene.'
        }],
        beforeandafter: [],
        testimonials: [
            'Dr. Aesha patiently explained my treatment options and answered all my questions, making me feel comfortable during  my treatment. It was the most comfortable treatment I have ever had. I am very happy with the results. Very hygienic clinic. 💯% recommended.👍 -- Nehal Patel',
            'Amazing experience with Pristine Smile, Dr Aesha has Great Hands on experience, knowledge and Apt facilities to restore your smile, pristine way. Mahi, supporting staff is also very helpful and soft spoken. Continuous chanting makes the environment divine. Highly appreciated and recommended. -- Yatin Baxi'
        ],
        relatedservices: [
            {
                detail: 'Crowns – Restore and protect damaged or broken teeth',
                link: '/crowns'
            },
            {
                detail: 'Root Canal – Save an infected or severely damaged tooth',
                link: '/root_canal'
            },
            {
                detail: 'Extractions – Gentle, pain-free removal of non-restorable teeth',
                link: '/extractions'
            }
        ]
    }, crowns: {
        title: 'Dental Crowns',
        tagline: 'Restore Strength, Function & Beauty to Your Smile!',
        overview: 'Dental crowns are custom-made tooth-shaped caps that restore the function, strength, and appearance of damaged or weakened teeth. Whether you have a cracked, decayed, or discolored tooth, a crown provides a durable and natural-looking solution to protect and enhance your smile.',
        benefits: [
            '✅ Strengthens and protects weak or damaged teeth',
            '✅ Restores the shape, size, and function of a tooth',
            '✅ Improves the appearance of stained or misshapen teeth',
            '✅ Long-lasting and durable, with proper care',
            '✅ Provides a seamless, natural look for a confident smile'
        ],
        symptoms: [
            '✔ A cracked, chipped, or fractured tooth',
            '✔ A tooth weakened by decay or large fillings',
            '✔ A tooth that has undergone a root canal',
            '✔ Severe discoloration or misshapen teeth',
            '✔ A missing tooth requiring a dental bridge anchor'
        ],
        treatment: [
            '1️⃣ Consultation & Assessment – We examine your tooth and take X-rays to determine the need for a crown.',
            '2️⃣ Tooth Preparation – The damaged tooth is reshaped to accommodate the crown.',
            '3️⃣ Digital Impressions – A precise mold or 3D scan is taken for a custom-fit crown.',
            '4️⃣ Temporary Crown Placement – A temporary crown is placed while your permanent one is being crafted.',
            '5️⃣ Permanent Crown Placement – Your custom-made crown is securely bonded for a perfect fit and function.'
        ],
        aftercare: [
            'Avoid chewing hard foods until the crown fully sets',
            'Maintain good oral hygiene with regular brushing and flossing',
            'Use a mouthguard if you grind your teeth at night',
            'Visit your dentist regularly for check-ups and cleanings',
            'With proper care, crowns can last 10-15 years or more'
        ],
        faq: [{
            question: 'How long do dental crowns last?',
            answer: 'With proper care, a high-quality dental crown can last between 10-15 years or even longer.'
        }, {
            question: 'Does getting a crown hurt?',
            answer: 'No, the procedure is performed under local anesthesia to ensure complete comfort.'
        }, {
            question: 'What materials are crowns made of?',
            answer: 'Crowns can be made from porcelain, ceramic, metal, or a combination, depending on your needs and preference.'
        }, {
            question: 'Can a crown look natural?',
            answer: 'Yes! Our custom-made crowns are designed to match the shape, size, and color of your natural teeth for a seamless appearance.'
        }],
        beforeandafter: [],
        testimonials: [
            'Dr. Aesha patiently explained my treatment options and answered all my questions, making me feel comfortable during  my treatment. It was the most comfortable treatment I have ever had. I am very happy with the results. Very hygienic clinic. 💯% recommended.👍 -- Nehal Patel',
            'Amazing experience with Pristine Smile, Dr Aesha has Great Hands on experience, knowledge and Apt facilities to restore your smile, pristine way. Mahi, supporting staff is also very helpful and soft spoken. Continuous chanting makes the environment divine. Highly appreciated and recommended. -- Yatin Baxi'
        ],
        relatedservices: [
            {
                detail: 'Dental Bridges – Replace missing teeth with a crown-supported bridge',
                link: '/bridges'
            },
            {
                detail: 'Root Canal – Protect and restore a tooth after a root canal treatment',
                link: '/root_canal'
            },
            {
                detail: 'Veneers – Cosmetic enhancement for front-facing teeth',
                link: '/veneers'
            }
        ]
    }, gum_therapy: {
        title: 'Gum Therapy',
        tagline: 'Healthy Gums, Stronger Smile!',
        overview: 'Gum health is essential for overall oral well-being. Gum therapy helps treat and prevent gum disease (gingivitis and periodontitis) to protect your teeth, reduce inflammation, and improve oral hygiene. Whether you have bleeding gums, sensitivity, or deep pockets around your teeth, our specialized gum treatments can restore and maintain your gum health.',
        benefits: [
            '✅ Treats and prevents gum disease (gingivitis and periodontitis)',
            '✅ Reduces inflammation, swelling, and gum sensitivity',
            '✅ Prevents tooth loss by strengthening gum support',
            '✅ Eliminates bad breath caused by gum infections',
            '✅ Improves overall oral and systemic health'
        ],
        symptoms: [
            '✔ Red, swollen, or bleeding gums',
            '✔ Persistent bad breath (halitosis)',
            '✔ Receding gums or teeth appearing longer',
            '✔ Pain or sensitivity when eating or brushing',
            '✔ Loose teeth or deep gum pockets'
        ],
        treatment: [
            '1️⃣ Comprehensive Gum Evaluation – We examine your gums and measure pocket depth to assess gum health.',
            '2️⃣ Scaling & Root Planing – A deep cleaning procedure to remove plaque and tartar buildup from beneath the gumline.',
            '3️⃣ Laser Gum Therapy (If Needed) – Advanced laser technology is used to disinfect and stimulate gum healing.',
            '4️⃣ Antibacterial Treatment – Medications or rinses may be prescribed to reduce bacterial infection.',
            '5️⃣ Ongoing Maintenance – Follow-up visits and personalized care plans help maintain gum health.'
        ],
        aftercare: [
            'Maintain daily brushing and flossing to prevent plaque buildup',
            'Use an antimicrobial mouthwash to reduce bacteria',
            'Avoid smoking or tobacco use, which worsens gum disease',
            'Eat a balanced diet rich in vitamins for gum health',
            'Schedule regular dental cleanings and check-ups'
        ],
        faq: [{
            question: 'Can gum disease be reversed?',
            answer: 'Early-stage gum disease (gingivitis) can be reversed with proper treatment and good oral hygiene. Advanced gum disease (periodontitis) can be managed but requires professional care.'
        }, {
            question: 'Is gum therapy painful?',
            answer: 'Scaling and root planing may cause slight discomfort, but we use local anesthesia to ensure a pain-free experience.'
        }, {
            question: 'How do I know if I need gum therapy?',
            answer: 'If you have bleeding gums, persistent bad breath, or gum recession, it’s best to consult a dentist for an evaluation.'
        }, {
            question: 'What happens if gum disease is left untreated?',
            answer: 'Untreated gum disease can lead to tooth loss, bone deterioration, and even contribute to systemic health issues like heart disease and diabetes.'
        }],
        beforeandafter: [],
        testimonials: [
            'Dr. Aesha patiently explained my treatment options and answered all my questions, making me feel comfortable during  my treatment. It was the most comfortable treatment I have ever had. I am very happy with the results. Very hygienic clinic. 💯% recommended.👍 -- Nehal Patel',
            'Amazing experience with Pristine Smile, Dr Aesha has Great Hands on experience, knowledge and Apt facilities to restore your smile, pristine way. Mahi, supporting staff is also very helpful and soft spoken. Continuous chanting makes the environment divine. Highly appreciated and recommended. -- Yatin Baxi'
        ],
        relatedservices: [
            {
                detail: 'Dental Cleanings – Prevent gum disease with regular professional cleanings',
                link: '/cleaning_exams'
            },
            {
                detail: 'Night Guards – Protect your teeth and gums from grinding damage',
                link: '/night_guard'
            },
            {
                detail: 'Dental Fillings – Restore teeth affected by decay and gum recession',
                link: '/dental_filling'
            }
        ]
    }, dental_filling: {
        title: 'Dental Fillings',
        tagline: 'Restore Strength & Prevent Decay!',
        overview: 'Dental fillings are a quick and effective solution to restore teeth affected by cavities, minor cracks, or wear. By removing decay and sealing the tooth with a durable filling material, we help prevent further damage and restore full function while maintaining a natural look.',
        benefits: [
            '✅ Stops tooth decay from spreading further',
            '✅ Restores the tooth’s structure, strength, and function',
            '✅ Blends seamlessly with your natural teeth for a discreet look',
            '✅ Prevents sensitivity and pain caused by cavities',
            '✅ A quick, long-lasting solution with minimal discomfort'
        ],
        symptoms: [
            '✔ Tooth sensitivity to hot, cold, or sweet foods',
            '✔ Visible holes, dark spots, or discoloration on the tooth',
            '✔ Pain or discomfort when chewing',
            '✔ Chipped or worn-down tooth surfaces',
            '✔ Food frequently getting stuck in a certain area of the tooth'
        ],
        treatment: [
            '1️⃣ Decay Removal – The damaged portion of the tooth is carefully cleaned and removed.',
            '2️⃣ Filling Placement – A tooth-colored composite or other material is applied to fill the cavity.',
            '3️⃣ Shaping & Bonding – The filling is shaped to match your natural tooth and bonded securely.',
            '4️⃣ Polishing & Final Check – The filled tooth is polished for a smooth finish, ensuring a comfortable bite.'
        ],
        aftercare: [
            'Avoid chewing hard or sticky foods immediately after the procedure',
            'Maintain proper oral hygiene by brushing and flossing daily',
            'Use a fluoride toothpaste to help strengthen enamel',
            'Reduce sugary foods and drinks to prevent future cavities',
            'Schedule regular dental check-ups to monitor filling longevity'
        ],
        faq: [{
            question: 'How long do dental fillings last?',
            answer: 'With proper care, composite fillings can last 5-10 years, while metal or ceramic fillings may last even longer.'
        }, {
            question: 'Is getting a filling painful?',
            answer: 'No, we use local anesthesia to numb the area, ensuring a comfortable and pain-free experience.'
        }, {
            question: 'What types of fillings are available?',
            answer: 'We offer composite (tooth-colored), amalgam (silver), ceramic, and gold fillings, depending on your needs and preferences.'
        }, {
            question: 'Can I eat immediately after getting a filling?',
            answer: 'It’s best to wait until the numbness wears off. Avoid chewing hard or sticky foods for at least 24 hours.'
        }],
        beforeandafter: [],
        testimonials: [
            'Dr. Aesha patiently explained my treatment options and answered all my questions, making me feel comfortable during  my treatment. It was the most comfortable treatment I have ever had. I am very happy with the results. Very hygienic clinic. 💯% recommended.👍 -- Nehal Patel',
            'Amazing experience with Pristine Smile, Dr Aesha has Great Hands on experience, knowledge and Apt facilities to restore your smile, pristine way. Mahi, supporting staff is also very helpful and soft spoken. Continuous chanting makes the environment divine. Highly appreciated and recommended. -- Yatin Baxi'
        ],
        relatedservices: [
            {
                detail: 'Crowns – Protect and restore teeth with extensive decay',
                link: '/crowns'
            },
            {
                detail: 'Root Canal – Save a severely decayed tooth from extraction',
                link: '/root_canal'
            },
            {
                detail: 'Dental Cleanings – Prevent cavities with routine professional cleanings',
                link: '/cleaning_exams'
            }
        ]
    }, denture: {
        title: 'Custom Dentures',
        tagline: 'Restore Your Smile & Confidence!',
        overview: 'Dentures are a comfortable, natural-looking solution for replacing missing teeth and restoring your smile. Whether you need full or partial dentures, our custom-made prosthetics allow you to eat, speak, and smile with confidence while maintaining proper oral function and facial structure.',
        benefits: [
            '✅ Restores the ability to chew and speak comfortably',
            '✅ Improves facial structure by preventing sagging',
            '✅ Custom-made for a comfortable and secure fit',
            '✅ Natural-looking aesthetics to enhance your smile',
            '✅ Affordable and effective tooth replacement option'
        ],
        symptoms: [
            '✔ Missing multiple or all teeth in the upper or lower jaw',
            '✔ Difficulty chewing or speaking due to missing teeth',
            '✔ Facial sagging or loss of lip support',
            '✔ Wanting a non-invasive alternative to implants',
            '✔ Seeking a cost-effective way to restore your smile'
        ],
        treatment: [
            '1️⃣ Consultation & Assessment – We evaluate your oral health and discuss the best denture options for you.',
            '2️⃣ Impressions & Custom Design – Digital or physical impressions are taken to create perfectly fitting dentures.',
            '3️⃣ Trial Fit – A temporary set may be tested to ensure comfort and alignment.',
            '4️⃣ Final Adjustments – Once finalized, we adjust the dentures for a snug and comfortable fit.',
            '5️⃣ Follow-Up Care – We provide guidance on wearing, cleaning, and maintaining your new dentures.'
        ],
        aftercare: [
            'Clean your dentures daily with a denture brush and mild cleanser',
            'Remove dentures at night to allow your gums to rest',
            'Soak dentures in a denture solution to keep them fresh',
            'Avoid hard or sticky foods that may damage dentures',
            'Visit your dentist regularly for adjustments and check-ups'
        ],
        faq: [{
            question: 'Are dentures comfortable to wear?',
            answer: 'Yes! Modern dentures are designed for comfort and a snug fit. Some initial adjustments may be needed for the best feel.'
        }, {
            question: 'How long do dentures last?',
            answer: 'With proper care, dentures can last 5-10 years before needing replacement or relining due to natural gum changes.'
        }, {
            question: 'Can I eat normally with dentures?',
            answer: 'Yes, but it may take some time to adjust. Start with soft foods and gradually introduce harder foods as you get used to them.'
        }, {
            question: 'What are the different types of dentures?',
            answer: 'We offer full dentures (for replacing all teeth), partial dentures (for missing multiple teeth), and implant-supported dentures for extra stability.'
        }],
        beforeandafter: [],
        testimonials: [
            'Dr. Aesha patiently explained my treatment options and answered all my questions, making me feel comfortable during  my treatment. It was the most comfortable treatment I have ever had. I am very happy with the results. Very hygienic clinic. 💯% recommended.👍 -- Nehal Patel',
            'Amazing experience with Pristine Smile, Dr Aesha has Great Hands on experience, knowledge and Apt facilities to restore your smile, pristine way. Mahi, supporting staff is also very helpful and soft spoken. Continuous chanting makes the environment divine. Highly appreciated and recommended. -- Yatin Baxi'
        ],
        relatedservices: [
            {
                detail: 'Implant-Supported Dentures – A secure alternative for added stability',
                link: '/implant_supported_dentures'
            },
            {
                detail: 'Crowns & Bridges – Other solutions for missing teeth',
                link: '/crowns'
            },
            {
                detail: 'Gum Therapy – Keep your gums healthy for long-lasting dentures',
                link: '/gum_therapy'
            }
        ]
    }, night_guard: {
        title: 'Custom Night Guards',
        tagline: 'Protect Your Teeth While You Sleep!',
        overview: 'Night guards are specially designed oral appliances that help protect your teeth from grinding (bruxism) and clenching while you sleep. If you wake up with jaw pain, headaches, or worn-down teeth, a custom night guard can provide relief, prevent damage, and improve your overall oral health.',
        benefits: [
            '✅ Prevents teeth grinding (bruxism) and enamel wear',
            '✅ Reduces jaw pain, headaches, and TMJ discomfort',
            '✅ Protects teeth from cracking, chipping, or fractures',
            '✅ Enhances sleep quality by relieving jaw tension',
            '✅ Custom-fit for maximum comfort and effectiveness'
        ],
        symptoms: [
            '✔ Waking up with jaw pain or tightness',
            '✔ Frequent headaches or facial soreness',
            '✔ Noticing worn-down, chipped, or sensitive teeth',
            '✔ Clicking or popping noises in the jaw',
            '✔ Being told you grind your teeth at night'
        ],
        treatment: [
            '1️⃣ Consultation & Diagnosis – We evaluate your symptoms and determine if a night guard is necessary.',
            '2️⃣ Custom Impressions – A precise mold is taken to create a night guard tailored to your bite.',
            '3️⃣ Fabrication Process – Your custom night guard is crafted using high-quality, durable materials.',
            '4️⃣ Fitting & Adjustments – We ensure a perfect fit for maximum comfort and protection.',
            '5️⃣ Usage & Care Instructions – Guidance on wearing and maintaining your night guard for long-term use.'
        ],
        aftercare: [
            'Clean your night guard daily with a soft brush and mild soap',
            'Store it in a ventilated case when not in use',
            'Avoid chewing on the night guard to prevent damage',
            'Bring your night guard to dental check-ups for adjustments',
            'Replace it if it shows signs of wear or discomfort over time'
        ],
        faq: [{
            question: 'How do I know if I need a night guard?',
            answer: 'If you experience jaw pain, frequent headaches, or signs of teeth grinding, a night guard can help prevent further damage and relieve discomfort.'
        }, {
            question: 'Are custom night guards better than over-the-counter ones?',
            answer: 'Yes! Custom night guards are more comfortable, durable, and provide a better fit compared to store-bought options, which can be bulky and ineffective.'
        }, {
            question: 'Can I talk or drink water while wearing a night guard?',
            answer: 'You can drink water, but speaking may take some adjustment initially. However, most patients get used to it quickly.'
        }, {
            question: 'How long does a night guard last?',
            answer: 'With proper care, a high-quality custom night guard can last 3-5 years before needing replacement.'
        }],
        beforeandafter: [],
        testimonials: [
            'Dr. Aesha patiently explained my treatment options and answered all my questions, making me feel comfortable during  my treatment. It was the most comfortable treatment I have ever had. I am very happy with the results. Very hygienic clinic. 💯% recommended.👍 -- Nehal Patel',
            'Amazing experience with Pristine Smile, Dr Aesha has Great Hands on experience, knowledge and Apt facilities to restore your smile, pristine way. Mahi, supporting staff is also very helpful and soft spoken. Continuous chanting makes the environment divine. Highly appreciated and recommended. -- Yatin Baxi'
        ],
        relatedservices: [
            {
                detail: 'TMJ Therapy – Treat jaw pain and tension from grinding',
                link: '/tmj_therapy'
            },
            {
                detail: 'Dental Crowns – Restore teeth damaged by grinding',
                link: '/crowns'
            }
        ]
    }, family_dentistry: {
        title: 'Family Dentistry',
        tagline: 'Comprehensive Care for Every Smile!',
        overview: 'Our family dentistry services provide complete oral care for patients of all ages, from young children to seniors. Whether it’s preventive care, restorative treatments, or cosmetic enhancements, we ensure that your entire family receives gentle, high-quality dental care in a comfortable and welcoming environment.',
        benefits: [
            '✅ One-stop dental care for the entire family',
            '✅ Preventive treatments to maintain lifelong oral health',
            '✅ Kid-friendly and senior-friendly approach for all ages',
            '✅ Early detection and treatment of dental issues',
            '✅ Convenient scheduling for families to save time'
        ],
        symptoms: [
            '✔ First dental visit for a child (recommended by age 1)',
            '✔ Regular check-ups and cleanings for the whole family',
            '✔ Cavities, gum disease, or tooth sensitivity concerns',
            '✔ Orthodontic or cosmetic dental needs for any family member',
            '✔ Dental care for seniors, including dentures and implants'
        ],
        treatment: [
            '1️⃣ Preventive Care – Routine cleanings, exams, and fluoride treatments to keep teeth healthy.',
            '2️⃣ Pediatric Dentistry – Gentle, fun, and stress-free dental visits for kids.',
            '3️⃣ Orthodontic Evaluations – Early screenings and treatments for bite and alignment issues.',
            '4️⃣ Restorative Dentistry – Fillings, crowns, and other treatments to restore dental health.',
            '5️⃣ Senior Dental Care – Specialized care for aging teeth, gums, and dentures.'
        ],
        aftercare: [
            'Encourage children to develop strong brushing and flossing habits',
            'Schedule regular dental check-ups for early detection of issues',
            'Maintain a balanced diet to promote healthy teeth and gums',
            'Use protective mouthguards for kids involved in sports',
            'Ensure seniors receive proper oral care, especially for dentures or implants'
        ],
        faq: [{
            question: 'At what age should my child first see a dentist?',
            answer: 'The American Dental Association recommends the first dental visit by age 1 or when the first tooth appears.'
        }, {
            question: 'How often should my family visit the dentist?',
            answer: 'We recommend dental check-ups and cleanings every six months for optimal oral health.'
        }, {
            question: 'Do you offer braces or Invisalign for kids and teens?',
            answer: 'Yes! We provide orthodontic screenings and refer for braces or Invisalign when necessary.'
        }, {
            question: 'Can family members schedule appointments together?',
            answer: 'Absolutely! We offer convenient scheduling options to accommodate multiple family members in one visit.'
        }],
        beforeandafter: [],
        testimonials: [
            'Dr. Aesha patiently explained my treatment options and answered all my questions, making me feel comfortable during  my treatment. It was the most comfortable treatment I have ever had. I am very happy with the results. Very hygienic clinic. 💯% recommended.👍 -- Nehal Patel',
            'Amazing experience with Pristine Smile, Dr Aesha has Great Hands on experience, knowledge and Apt facilities to restore your smile, pristine way. Mahi, supporting staff is also very helpful and soft spoken. Continuous chanting makes the environment divine. Highly appreciated and recommended. -- Yatin Baxi'
        ],
        relatedservices: [
            {
                detail: 'Pediatric Dentistry – Specialized care for children’s growing smiles',
                link: '/pediatric_dentistry'
            },
            {
                detail: 'Cleanings & Exams – Routine check-ups for long-term oral health',
                link: '/cleaning'
            },
            {
                detail: 'Orthodontic Care – Invisalign and braces for teens and adults',
                link: '/orthodontic_care'
            }
        ]
    }, invisalign: {
        title: 'Invisalign Clear Aligners',
        tagline: 'Discreetly Straighten Your Smile!',
        overview: 'Invisalign is a modern, comfortable, and nearly invisible way to straighten your teeth without the hassle of traditional metal braces. Using custom-made, clear aligners, Invisalign gradually shifts your teeth into perfect alignment while allowing you to eat, speak, and smile with confidence.',
        servicePartnerInstruction: true,
        isInsuranceAvailable: true,
        benefits: [
            '✅ Virtually invisible for a discreet orthodontic treatment',
            '✅ Comfortable and removable aligners for convenience',
            '✅ No food restrictions—eat whatever you like!',
            '✅ Faster results compared to traditional braces',
            '✅ Fewer dental visits needed for adjustments'
        ],
        symptoms: [
            '✔ Crooked or misaligned teeth',
            '✔ Gaps between teeth',
            '✔ Overbite, underbite, or crossbite',
            '✔ Crowded teeth causing discomfort or difficulty cleaning',
            '✔ Wanting a straighter smile without metal braces'
        ],
        treatment: [
            '1️⃣ Consultation & 3D Scan – We evaluate your teeth and create a digital preview of your future smile.',
            '2️⃣ Custom Aligners Fabrication – A series of clear, removable aligners are designed specifically for you.',
            '3️⃣ Wearing Aligners – You wear each set for about two weeks, gradually shifting your teeth.',
            '4️⃣ Progress Checkups – We monitor your progress with occasional visits, ensuring your teeth are moving correctly.',
            '5️⃣ Retainers & Smile Maintenance – Once treatment is complete, retainers help maintain your new, perfect smile.'
        ],
        aftercare: [
            'Wear your aligners for 20-22 hours a day for optimal results',
            'Remove aligners before eating or drinking anything except water',
            'Clean aligners daily with mild soap and water (avoid toothpaste)',
            'Use retainers as directed after treatment to maintain your results',
            'Keep up with routine dental check-ups to ensure long-term oral health'
        ],
        faq: [{
            question: 'How long does Invisalign treatment take?',
            answer: 'The average treatment time is 6-18 months, depending on the complexity of your case.'
        }, {
            question: 'Is Invisalign better than traditional braces?',
            answer: 'Invisalign offers a discreet, comfortable, and removable alternative to braces, making it a preferred option for many adults and teens.'
        }, {
            question: 'Can I eat with Invisalign aligners in?',
            answer: 'No, you should remove them before eating or drinking anything other than water to prevent damage and staining.'
        }, {
            question: 'Is Invisalign treatment painful?',
            answer: 'Some mild discomfort may occur as your teeth shift, but it’s much less painful than traditional braces.'
        }],
        beforeandafter: [],
        testimonials: [
            'Dr. Aesha patiently explained my treatment options and answered all my questions, making me feel comfortable during  my treatment. It was the most comfortable treatment I have ever had. I am very happy with the results. Very hygienic clinic. 💯% recommended.👍 -- Nehal Patel',
            'Amazing experience with Pristine Smile, Dr Aesha has Great Hands on experience, knowledge and Apt facilities to restore your smile, pristine way. Mahi, supporting staff is also very helpful and soft spoken. Continuous chanting makes the environment divine. Highly appreciated and recommended. -- Yatin Baxi'
        ],
        relatedservices: [
            {
                detail: 'Teeth Whitening – Enhance your new straight smile with professional whitening',
                link: '/teeth_whitening'
            },
            {
                detail: 'Bonding – Fix small gaps or chips for a flawless smile',
                link: '/bonding'
            },
            {
                detail: 'Smile Makeover – Combine Invisalign with other cosmetic treatments for a full transformation',
                link: '/smile_makeover'
            }
        ]
    }, teeth_whitening: {
        title: 'Professional Teeth Whitening',
        tagline: 'Brighten Your Smile, Boost Your Confidence!',
        overview: 'Teeth whitening is a safe and effective way to remove stains and discoloration, leaving your smile visibly brighter and more radiant. Whether you choose our in-office whitening or custom take-home kits, we offer solutions that deliver fast, noticeable results with minimal sensitivity.',
        benefits: [
            '✅ Instantly brightens your smile by several shades',
            '✅ Removes stains caused by coffee, tea, wine, and smoking',
            '✅ Boosts self-confidence with a whiter, cleaner-looking smile',
            '✅ Safe, dentist-approved formulas that minimize sensitivity',
            '✅ Available in both in-office and take-home options'
        ],
        symptoms: [
            '✔ Dull, yellowed, or stained teeth',
            '✔ Stains from coffee, tea, red wine, or tobacco',
            '✔ Uneven tooth coloration',
            '✔ Wanting a whiter smile for a special event or photos',
            '✔ Looking to enhance results after straightening or cosmetic work'
        ],
        treatment: [
            '1️⃣ Consultation & Shade Assessment – We evaluate your current tooth color and discuss your whitening goals.',
            '2️⃣ In-Office Whitening (Optional) – A powerful bleaching agent is applied and activated with light for instant results.',
            '3️⃣ Take-Home Whitening Kits – Custom trays and professional-grade gel are provided for whitening at your convenience.',
            '4️⃣ Ongoing Monitoring – We track your results and provide guidance for safe, effective use.',
            '5️⃣ Maintenance Advice – Tips and products are recommended to help maintain your bright smile long-term.'
        ],
        aftercare: [
            'Avoid staining foods and drinks (coffee, wine, berries) for 24-48 hours post-treatment',
            'Use a straw when drinking beverages that can stain teeth',
            'Brush with a whitening toothpaste and rinse with water after meals',
            'Avoid tobacco products to preserve results',
            'Schedule touch-up treatments as needed to maintain brightness'
        ],
        faq: [{
            question: 'Is teeth whitening safe?',
            answer: 'Yes! Our professional whitening systems are safe and supervised by dental experts to protect your enamel and gums.'
        }, {
            question: 'How long do results last?',
            answer: 'Results can last from 6 months to 2 years, depending on your lifestyle and oral care habits.'
        }, {
            question: 'Will teeth whitening cause sensitivity?',
            answer: 'Some patients may experience mild sensitivity, but it’s temporary and we use solutions that minimize discomfort.'
        }, {
            question: 'Can I whiten crowns or veneers?',
            answer: 'Whitening treatments only work on natural teeth. We’ll discuss options for matching dental work if needed.'
        }],
        beforeandafter: [],
        testimonials: [
            'Dr. Aesha patiently explained my treatment options and answered all my questions, making me feel comfortable during  my treatment. It was the most comfortable treatment I have ever had. I am very happy with the results. Very hygienic clinic. 💯% recommended.👍 -- Nehal Patel',
            'Amazing experience with Pristine Smile, Dr Aesha has Great Hands on experience, knowledge and Apt facilities to restore your smile, pristine way. Mahi, supporting staff is also very helpful and soft spoken. Continuous chanting makes the environment divine. Highly appreciated and recommended. -- Yatin Baxi'
        ],
        relatedservices: [
            {
                detail: 'Veneers – Cover deep discoloration that whitening may not fully remove',
                link: '/veneers'
            },
            {
                detail: 'Dental Cleaning – Start with a clean slate for the best whitening results',
                link: '/cleaning_exams'
            },
            {
                detail: 'Smile Makeover – Combine whitening with cosmetic treatments for a complete transformation',
                link: '/smile_makeover'
            }
        ]
    }, bonding: {
        title: 'Dental Bonding',
        tagline: 'Quick Fixes for a Flawless Smile!',
        overview: 'Dental bonding is a fast, non-invasive cosmetic procedure that uses tooth-colored resin to repair chips, cracks, gaps, and discoloration. It’s an affordable and effective way to enhance your smile in just one visit—no anesthesia or downtime required.',
        benefits: [
            '✅ Instantly improves the appearance of chipped, cracked, or stained teeth',
            '✅ Fills small gaps between teeth for a more even smile',
            '✅ Quick, painless treatment completed in a single visit',
            '✅ Matches your natural tooth color for a seamless look',
            '✅ Cost-effective alternative to veneers or crowns'
        ],
        symptoms: [
            '✔ Small chips or cracks in the front teeth',
            '✔ Gaps between teeth you want to close',
            '✔ Discoloration or uneven tooth surfaces',
            '✔ Minor shape or size irregularities',
            '✔ Looking for a quick and affordable cosmetic fix'
        ],
        treatment: [
            '1️⃣ Smile Evaluation – We assess your teeth and discuss your goals for bonding.',
            '2️⃣ Surface Preparation – The tooth surface is lightly etched and conditioned for bonding.',
            '3️⃣ Composite Application – A tooth-colored resin is applied, sculpted, and shaped to the desired look.',
            '4️⃣ Hardening – A special light is used to cure and harden the resin.',
            '5️⃣ Finishing Touch – The bonded area is polished to blend naturally with your tooth.'
        ],
        aftercare: [
            'Avoid biting hard objects (pens, ice, nails) to prevent chipping',
            'Brush and floss regularly to maintain your bonding',
            'Limit consumption of staining foods and drinks (coffee, wine)',
            'Avoid smoking to preserve bonding color',
            'Schedule routine check-ups to ensure longevity and touch-ups if needed'
        ],
        faq: [{
            question: 'How long does dental bonding last?',
            answer: 'Bonding typically lasts 5–10 years with good oral care and no habits like nail-biting or chewing hard objects.'
        }, {
            question: 'Is dental bonding painful?',
            answer: 'No, bonding is non-invasive and usually requires no anesthesia unless it’s used to fill a cavity.'
        }, {
            question: 'Can bonding fix gaps between teeth?',
            answer: 'Yes! Bonding is a great solution for closing small gaps without braces or aligners.'
        }, {
            question: 'Will the bonding match my natural teeth?',
            answer: 'Absolutely. We carefully match the resin color to your natural teeth for a flawless result.'
        }],
        beforeandafter: [],
        testimonials: [
            'Dr. Aesha patiently explained my treatment options and answered all my questions, making me feel comfortable during  my treatment. It was the most comfortable treatment I have ever had. I am very happy with the results. Very hygienic clinic. 💯% recommended.👍 -- Nehal Patel',
            'Amazing experience with Pristine Smile, Dr Aesha has Great Hands on experience, knowledge and Apt facilities to restore your smile, pristine way. Mahi, supporting staff is also very helpful and soft spoken. Continuous chanting makes the environment divine. Highly appreciated and recommended. -- Yatin Baxi'
        ],
        relatedservices: [
            {
                detail: 'Veneers – For more durable and long-term cosmetic enhancement',
                link: '/veneers'
            },
            {
                detail: 'Teeth Whitening – Brighten your overall smile before bonding for a perfect shade match',
                link: '/teeth_whitening'
            },
            {
                detail: 'Smile Makeover – Combine bonding with other treatments for full smile enhancement',
                link: '/smile_makeover'
            }
        ]
    }, veneers: {
        title: 'Porcelain Veneers',
        tagline: 'Redesign Your Smile with Stunning Precision!',
        overview: 'Veneers are ultra-thin, custom-made shells bonded to the front of your teeth to instantly improve their appearance. They’re perfect for covering stains, closing gaps, fixing chips, or creating a more uniform smile. With veneers, you can achieve a radiant, flawless look that’s both natural and long-lasting.',
        benefits: [
            '✅ Instantly enhances the shape, color, and alignment of teeth',
            '✅ Covers chips, cracks, stains, and gaps',
            '✅ Custom-designed for a natural and balanced appearance',
            '✅ Durable and stain-resistant material',
            '✅ A long-lasting solution for a picture-perfect smile'
        ],
        symptoms: [
            '✔ Discolored or permanently stained teeth',
            '✔ Worn down, chipped, or broken teeth',
            '✔ Gaps between front teeth',
            '✔ Slightly misaligned or uneven teeth',
            '✔ Wanting a complete cosmetic transformation'
        ],
        treatment: [
            '1️⃣ Smile Consultation – We discuss your goals and evaluate your smile with photos and digital imaging.',
            '2️⃣ Tooth Preparation – A minimal amount of enamel is gently removed to prepare the tooth surface.',
            '3️⃣ Impressions – We take detailed impressions to design your custom veneers.',
            '4️⃣ Temporary Veneers – Temporary veneers may be placed while your permanent ones are crafted.',
            '5️⃣ Final Placement – Your porcelain veneers are bonded to your teeth and polished to perfection.'
        ],
        aftercare: [
            'Avoid biting on hard items (e.g., pens, ice, fingernails)',
            'Brush and floss regularly with a non-abrasive toothpaste',
            'Minimize foods and drinks that may stain (coffee, wine)',
            'Wear a night guard if you grind your teeth',
            'Visit your dentist regularly for check-ups and maintenance'
        ],
        faq: [{
            question: 'Are veneers permanent?',
            answer: 'Yes, because a small amount of enamel is removed, veneers are considered a permanent cosmetic treatment.'
        }, {
            question: 'Do veneers look natural?',
            answer: 'Absolutely! Veneers are custom-designed to match your natural teeth in color, shape, and size for a realistic look.'
        }, {
            question: 'How long do veneers last?',
            answer: 'With proper care, veneers can last 10–15 years or longer before needing replacement.'
        }, {
            question: 'Is the veneer procedure painful?',
            answer: 'The procedure is minimally invasive and generally pain-free, often requiring little to no anesthesia.'
        }],
        beforeandafter: [],
        testimonials: [
            'Dr. Aesha patiently explained my treatment options and answered all my questions, making me feel comfortable during  my treatment. It was the most comfortable treatment I have ever had. I am very happy with the results. Very hygienic clinic. 💯% recommended.👍 -- Nehal Patel',
            'Amazing experience with Pristine Smile, Dr Aesha has Great Hands on experience, knowledge and Apt facilities to restore your smile, pristine way. Mahi, supporting staff is also very helpful and soft spoken. Continuous chanting makes the environment divine. Highly appreciated and recommended. -- Yatin Baxi'
        ],
        relatedservices: [
            {
                detail: 'Teeth Whitening – Brighten surrounding teeth before getting veneers for a perfect match',
                link: '/teeth_whitening'
            },
            {
                detail: 'Bonding – A quick alternative for minor chips or gaps',
                link: '/bonding'
            },
            {
                detail: 'Smile Makeover – Combine veneers with other cosmetic treatments for full transformation',
                link: '/smile_makeover'
            }
        ]
    }, smile_makeover: {
        title: 'Smile Makeover',
        tagline: 'Your Dream Smile, Designed Just for You!',
        overview: 'A smile makeover is a fully personalized combination of cosmetic and restorative dental treatments designed to completely transform your smile. Whether you’re dealing with stained, chipped, misaligned, or missing teeth, we’ll craft a custom treatment plan to enhance aesthetics, boost confidence, and improve overall oral health.',
        benefits: [
            '✅ Comprehensive transformation tailored to your goals',
            '✅ Combines multiple cosmetic procedures for dramatic results',
            '✅ Improves both appearance and functionality of your teeth',
            '✅ Boosts confidence and self-esteem',
            '✅ Long-lasting results with a natural-looking finish'
        ],
        symptoms: [
            '✔ Multiple cosmetic concerns like discoloration, gaps, or crooked teeth',
            '✔ Chipped, worn, or uneven teeth',
            '✔ Missing or damaged teeth',
            '✔ Feeling self-conscious about your smile',
            '✔ Looking for a complete smile transformation before a big life event'
        ],
        treatment: [
            '1️⃣ Smile Assessment – We begin with a consultation, photos, and digital scans to evaluate your current smile and desired outcome.',
            '2️⃣ Customized Treatment Plan – Based on your goals, we design a personalized plan using one or more procedures.',
            '3️⃣ Cosmetic Treatments – May include teeth whitening, bonding, veneers, Invisalign, or Botox.',
            '4️⃣ Restorative Procedures – May include crowns, bridges, implants, or gum reshaping for function and aesthetics.',
            '5️⃣ Final Refinements – We ensure every detail is perfected for a beautiful, balanced, and natural-looking smile.'
        ],
        aftercare: [
            'Maintain excellent oral hygiene to protect your new smile',
            'Attend all follow-up visits to monitor your results',
            'Use whitening toothpaste and avoid staining foods when applicable',
            'Wear retainers or night guards if part of your treatment plan',
            'Keep up with regular cleanings and exams to ensure long-term success'
        ],
        faq: [{
            question: 'What’s included in a smile makeover?',
            answer: 'It depends on your needs and goals. Common treatments include veneers, whitening, Invisalign, crowns, bonding, and gum contouring.'
        }, {
            question: 'How long does a smile makeover take?',
            answer: 'It varies by treatment—some can be completed in one visit, while full makeovers may take several weeks or months.'
        }, {
            question: 'Is a smile makeover painful?',
            answer: 'Most procedures are minimally invasive and performed with comfort in mind. We’ll ensure you’re relaxed and pain-free throughout.'
        }, {
            question: 'Will my results look natural?',
            answer: 'Yes! We design every smile makeover to enhance your features and match your natural teeth for a beautiful, believable result.'
        }],
        beforeandafter: [],
        testimonials: [
            'Dr. Aesha patiently explained my treatment options and answered all my questions, making me feel comfortable during  my treatment. It was the most comfortable treatment I have ever had. I am very happy with the results. Very hygienic clinic. 💯% recommended.👍 -- Nehal Patel',
            'Amazing experience with Pristine Smile, Dr Aesha has Great Hands on experience, knowledge and Apt facilities to restore your smile, pristine way. Mahi, supporting staff is also very helpful and soft spoken. Continuous chanting makes the environment divine. Highly appreciated and recommended. -- Yatin Baxi'
        ],
        relatedservices: [
            {
                detail: 'Veneers – Cover imperfections and create a flawless appearance',
                link: '/veneers'
            },
            {
                detail: 'Invisalign – Straighten teeth as part of your transformation',
                link: '/invisalign'
            },
            {
                detail: 'Teeth Whitening – Brighten your smile for a radiant finish',
                link: '/teeth_whitening'
            }
        ]
    }, implants: {
        title: 'Dental Implants',
        tagline: 'Permanent Tooth Replacement That Looks and Feels Natural!',
        overview: 'Dental implants are a long-lasting, natural-looking solution for replacing missing teeth. Surgically placed into the jawbone, implants act as artificial tooth roots that support crowns, bridges, or dentures. They restore your ability to chew, speak, and smile with confidence—while preserving bone health and facial structure.',
        benefits: [
            '✅ Permanent and stable tooth replacement',
            '✅ Looks, feels, and functions like a natural tooth',
            '✅ Prevents bone loss and maintains facial structure',
            '✅ Does not rely on adjacent teeth like bridges',
            '✅ Restores chewing efficiency and clear speech'
        ],
        symptoms: [
            '✔ Missing one or more teeth',
            '✔ Difficulty chewing or speaking due to missing teeth',
            '✔ Wanting a fixed alternative to dentures',
            '✔ Jawbone loss or facial sagging due to tooth loss',
            '✔ Looking for a long-term, natural-feeling solution'
        ],
        treatment: [
            '1️⃣ Consultation & 3D Imaging – We evaluate your oral health and use digital scans to assess bone structure and plan your implant placement.',
            '2️⃣ Surgical Placement – The implant post is placed into the jawbone and allowed to heal and fuse (osseointegration).',
            '3️⃣ Healing Period – Typically 3–6 months, during which the implant integrates with the bone.',
            '4️⃣ Abutment Placement – A small connector is attached to the implant post once healing is complete.',
            '5️⃣ Crown Placement – A custom-made crown is secured on top, completing your new tooth.'
        ],
        aftercare: [
            'Maintain excellent oral hygiene to protect your implant and surrounding gums',
            'Avoid hard or sticky foods while healing',
            'Attend all scheduled follow-ups to monitor implant integration',
            'Brush and floss around the implant daily',
            'Schedule regular professional cleanings and check-ups'
        ],
        faq: [{
            question: 'Are dental implants permanent?',
            answer: 'Yes, with proper care, dental implants can last a lifetime. The crown may need replacement after 10–15 years due to normal wear.'
        }, {
            question: 'Is the implant procedure painful?',
            answer: 'The procedure is performed under local anesthesia and is generally well-tolerated. Mild soreness afterward can be managed with over-the-counter medication.'
        }, {
            question: 'How long does the implant process take?',
            answer: 'The full process typically takes 3–6 months to allow for proper healing and osseointegration.'
        }, {
            question: 'Am I a good candidate for implants?',
            answer: 'Most healthy adults with good oral hygiene and adequate jawbone density are candidates. A consultation will confirm your eligibility.'
        }],
        beforeandafter: [],
        testimonials: [
            'Dr. Aesha patiently explained my treatment options and answered all my questions, making me feel comfortable during  my treatment. It was the most comfortable treatment I have ever had. I am very happy with the results. Very hygienic clinic. 💯% recommended.👍 -- Nehal Patel',
            'Amazing experience with Pristine Smile, Dr Aesha has Great Hands on experience, knowledge and Apt facilities to restore your smile, pristine way. Mahi, supporting staff is also very helpful and soft spoken. Continuous chanting makes the environment divine. Highly appreciated and recommended. -- Yatin Baxi'
        ],
        relatedservices: [
            {
                detail: 'Bone Grafts – Build jawbone strength if needed before implant placement',
                link: '/bone_grafts'
            },
            {
                detail: 'Implant-Supported Dentures – Secure, full-arch tooth replacement using implants',
                link: '/implant_supported_dentures'
            },
            {
                detail: 'Dental Crowns – The finishing touch for your implant restoration',
                link: '/crowns'
            }
        ]
    }, extractions: {
        title: 'Tooth Extractions',
        tagline: 'Gentle, Safe Removal for Healthier Smiles!',
        overview: 'Tooth extractions are sometimes necessary to protect your overall oral health. Whether it’s due to decay, infection, crowding, or impacted wisdom teeth, our team ensures the extraction process is safe, comfortable, and stress-free. We also provide guidance on tooth replacement options to restore your smile.',
        benefits: [
            '✅ Removes damaged, infected, or problematic teeth',
            '✅ Relieves pain and prevents the spread of infection',
            '✅ Creates space for orthodontic treatment when needed',
            '✅ Safe and efficient procedure with gentle techniques',
            '✅ Options available for tooth replacement post-extraction'
        ],
        symptoms: [
            '✔ Severe tooth pain or infection',
            '✔ Impacted or partially erupted wisdom teeth',
            '✔ Advanced tooth decay or gum disease',
            '✔ Overcrowded teeth needing space for alignment',
            '✔ Broken teeth that cannot be restored'
        ],
        treatment: [
            '1️⃣ Examination & X-rays – We evaluate the affected tooth and surrounding area using digital imaging.',
            '2️⃣ Local Anesthesia – The area is numbed to ensure a pain-free experience.',
            '3️⃣ Tooth Removal – The tooth is gently loosened and removed using precise techniques.',
            '4️⃣ Surgical Extraction (if needed) – For impacted or broken teeth, a small incision may be required.',
            '5️⃣ Aftercare Instructions – We provide detailed guidance for healing and next steps, including replacement options if needed.'
        ],
        aftercare: [
            'Bite on gauze for 30–45 minutes to control bleeding',
            'Avoid rinsing, spitting, or using a straw for 24 hours',
            'Eat soft foods and stay hydrated',
            'Use ice packs to reduce swelling',
            'Follow all aftercare instructions and attend follow-ups'
        ],
        faq: [{
            question: 'Is a tooth extraction painful?',
            answer: 'No, the procedure is performed under local anesthesia to keep you comfortable. You may experience mild soreness afterward, which is manageable with pain relievers.'
        }, {
            question: 'How long does recovery take?',
            answer: 'Most patients heal within a few days to a week. We’ll provide instructions to ensure proper healing and avoid complications.'
        }, {
            question: 'Do I need to replace a tooth after extraction?',
            answer: 'In most cases, yes. Replacing a missing tooth helps maintain proper bite alignment and jaw health. We’ll discuss the best replacement options with you.'
        }, {
            question: 'When is a surgical extraction needed?',
            answer: 'Surgical extractions are used for impacted teeth, such as wisdom teeth, or teeth broken at the gumline.'
        }],
        beforeandafter: [],
        testimonials: [
            'Dr. Aesha patiently explained my treatment options and answered all my questions, making me feel comfortable during  my treatment. It was the most comfortable treatment I have ever had. I am very happy with the results. Very hygienic clinic. 💯% recommended.👍 -- Nehal Patel',
            'Amazing experience with Pristine Smile, Dr Aesha has Great Hands on experience, knowledge and Apt facilities to restore your smile, pristine way. Mahi, supporting staff is also very helpful and soft spoken. Continuous chanting makes the environment divine. Highly appreciated and recommended. -- Yatin Baxi'
        ],
        relatedservices: [
            {
                detail: 'Dental Implants – Permanent solution for replacing extracted teeth',
                link: '/implants'
            },
            {
                detail: 'Bridges – Restore missing teeth with a natural-looking dental bridge',
                link: '/bridges'
            },
            {
                detail: 'Bone Grafts – Preserve jaw structure after tooth removal if implant is planned',
                link: '/bone_grafts'
            }
        ]
    }, root_canal: {
        title: 'Root Canal Therapy',
        tagline: 'Save Your Natural Tooth & Eliminate Pain!',
        overview: 'Root canal therapy is a highly effective treatment used to save a severely decayed or infected tooth. Instead of removing the tooth, this procedure cleans out the infected pulp, seals the tooth, and restores its function with a crown—relieving pain and preserving your natural smile.',
        benefits: [
            '✅ Eliminates tooth pain and infection',
            '✅ Saves your natural tooth from extraction',
            '✅ Restores normal chewing and bite function',
            '✅ Prevents the spread of infection to surrounding teeth',
            '✅ Strengthens the tooth with a crown for long-term use'
        ],
        symptoms: [
            '✔ Persistent toothache or sensitivity to hot and cold',
            '✔ Swelling or tenderness around the gums',
            '✔ Darkening or discoloration of the tooth',
            '✔ Pain when chewing or touching the tooth',
            '✔ Deep decay or trauma to the tooth'
        ],
        treatment: [
            '1️⃣ Examination & X-rays – We assess the tooth and surrounding bone to confirm infection and treatment needs.',
            '2️⃣ Local Anesthesia – The area is numbed for a pain-free experience.',
            '3️⃣ Cleaning the Canals – The infected pulp and bacteria are removed from inside the tooth.',
            '4️⃣ Filling & Sealing – The canals are filled and sealed with a biocompatible material to prevent reinfection.',
            '5️⃣ Crown Placement – A custom crown is placed to protect and restore the tooth’s function and appearance.'
        ],
        aftercare: [
            'Avoid chewing on the treated side until the final crown is placed',
            'Maintain regular brushing and flossing to keep the area clean',
            'Take prescribed antibiotics or pain medication as directed',
            'Attend follow-up appointments to ensure proper healing',
            'Let your dentist know if you experience prolonged discomfort or swelling'
        ],
        faq: [{
            question: 'Is a root canal painful?',
            answer: 'No, modern root canals are performed under local anesthesia and are generally no more uncomfortable than getting a filling.'
        }, {
            question: 'How long does a root canal take?',
            answer: 'Most root canals can be completed in one or two visits, depending on the severity of the infection and the tooth’s condition.'
        }, {
            question: 'Will I need a crown after a root canal?',
            answer: 'Yes, in most cases, a crown is recommended to restore strength and prevent the tooth from breaking.'
        }, {
            question: 'What happens if I delay a root canal?',
            answer: 'Delaying treatment can lead to increased pain, tooth loss, and the spread of infection to surrounding tissues or bone.'
        }],
        beforeandafter: [],
        testimonials: [
            'Dr. Aesha patiently explained my treatment options and answered all my questions, making me feel comfortable during  my treatment. It was the most comfortable treatment I have ever had. I am very happy with the results. Very hygienic clinic. 💯% recommended.👍 -- Nehal Patel',
            'Amazing experience with Pristine Smile, Dr Aesha has Great Hands on experience, knowledge and Apt facilities to restore your smile, pristine way. Mahi, supporting staff is also very helpful and soft spoken. Continuous chanting makes the environment divine. Highly appreciated and recommended. -- Yatin Baxi'
        ],
        relatedservices: [
            {
                detail: 'Crowns – Final restoration to protect the treated tooth',
                link: '/crowns'
            },
            {
                detail: 'Dental Fillings – Repair small cavities before they become more serious',
                link: '/dental_filling'
            },
            {
                detail: 'Extractions – An alternative if a tooth is too damaged to be saved',
                link: '/extractions'
            }
        ]
    }, bone_grafts: {
        title: 'Dental Bone Grafts',
        tagline: 'Rebuild Your Jaw, Restore Your Smile!',
        overview: 'Bone grafting is a surgical procedure that restores and strengthens the jawbone, often needed before placing dental implants or after tooth loss. By rebuilding the bone structure, bone grafts provide the foundation necessary for long-term dental health, stability, and function.',
        benefits: [
            '✅ Rebuilds bone loss caused by tooth loss or gum disease',
            '✅ Provides a strong foundation for dental implants',
            '✅ Preserves facial structure and prevents sagging',
            '✅ Enhances stability of surrounding teeth',
            '✅ Promotes natural bone regeneration over time'
        ],
        symptoms: [
            '✔ Missing teeth and planning to receive dental implants',
            '✔ Jawbone loss visible in X-rays or scans',
            '✔ Teeth shifting or loosening due to lack of bone support',
            '✔ Facial sagging or changes in appearance after tooth loss',
            '✔ Previous extractions that left bone volume compromised'
        ],
        treatment: [
            '1️⃣ Consultation & Imaging – We assess your jawbone health using digital X-rays or 3D imaging.',
            '2️⃣ Treatment Planning – We determine the type of graft needed (autograft, allograft, xenograft, or synthetic).',
            '3️⃣ Graft Placement – Bone material is placed in the affected area to stimulate growth and regeneration.',
            '4️⃣ Healing Period – Over the next few months, your natural bone integrates with the graft material.',
            '5️⃣ Follow-Up & Implant Preparation – Once healed, the area is ready for implants or other restorative treatments.'
        ],
        aftercare: [
            'Avoid putting pressure on the graft site',
            'Follow a soft food diet during the healing phase',
            'Take all prescribed antibiotics or medications as directed',
            'Rinse gently and maintain excellent oral hygiene',
            'Attend all scheduled follow-up visits for monitoring'
        ],
        faq: [{
            question: 'Is a bone graft necessary before getting implants?',
            answer: 'Yes, if there isn’t enough bone volume to support an implant, a bone graft helps build the structure needed for long-term success.'
        }, {
            question: 'Is the bone graft procedure painful?',
            answer: 'The procedure is done under local anesthesia and is well tolerated. Mild swelling or discomfort afterward is normal and manageable.'
        }, {
            question: 'How long does it take to heal after a bone graft?',
            answer: 'Healing usually takes 3–6 months, depending on the size of the graft and your body’s natural healing ability.'
        }, {
            question: 'What type of bone is used for grafting?',
            answer: 'We use biocompatible options including your own bone (autograft), donor bone (allograft), animal bone (xenograft), or synthetic materials.'
        }],
        beforeandafter: [],
        testimonials: [
            'Dr. Aesha patiently explained my treatment options and answered all my questions, making me feel comfortable during  my treatment. It was the most comfortable treatment I have ever had. I am very happy with the results. Very hygienic clinic. 💯% recommended.👍 -- Nehal Patel',
            'Amazing experience with Pristine Smile, Dr Aesha has Great Hands on experience, knowledge and Apt facilities to restore your smile, pristine way. Mahi, supporting staff is also very helpful and soft spoken. Continuous chanting makes the environment divine. Highly appreciated and recommended. -- Yatin Baxi'
        ],
        relatedservices: [
            {
                detail: 'Dental Implants – Secure and permanent tooth replacements after graft healing',
                link: '/implants'
            },
            {
                detail: 'Extractions – Bone grafting is often performed immediately after a tooth removal',
                link: '/extractions'
            },
            {
                detail: 'Implant-Supported Dentures – Strong bone is essential for long-lasting, stable dentures',
                link: '/implant_supported_dentures'
            }
        ]
    }, implant_supported_dentures: {
        title: 'Implant-Supported Dentures',
        tagline: 'Secure, Stable & Natural-Looking Smile Restoration!',
        overview: 'Implant-supported dentures combine the full coverage of traditional dentures with the stability and strength of dental implants. By anchoring dentures to implants placed in the jawbone, this solution eliminates slipping, improves chewing ability, and restores confidence with a secure, natural-feeling fit.',
        benefits: [
            '✅ Dentures stay firmly in place—no slipping or adhesives',
            '✅ Improved chewing efficiency and speech clarity',
            '✅ Helps preserve jawbone and facial structure',
            '✅ More comfortable and stable than traditional dentures',
            '✅ Long-lasting, functional, and natural-looking solution'
        ],
        symptoms: [
            '✔ Difficulty chewing or speaking with loose dentures',
            '✔ Jawbone loss or facial sagging due to missing teeth',
            '✔ Frustration with messy adhesives or frequent denture adjustments',
            '✔ Wanting a more secure, permanent alternative to traditional dentures',
            '✔ Looking to restore a full arch of teeth with improved comfort'
        ],
        treatment: [
            '1️⃣ Consultation & Imaging – We assess bone health and determine implant placement using digital scans.',
            '2️⃣ Implant Placement – 2 to 6 implants are surgically placed in the jawbone depending on your case.',
            '3️⃣ Healing & Osseointegration – Over 3–6 months, implants fuse with the bone for a strong foundation.',
            '4️⃣ Custom Denture Fabrication – A denture is crafted to securely attach to the implants.',
            '5️⃣ Final Attachment – The denture is clipped or screwed into place for a stable, confident fit.'
        ],
        aftercare: [
            'Maintain excellent oral hygiene, including cleaning around implants',
            'Remove and clean dentures daily if they are removable type',
            'Schedule regular dental check-ups to monitor implant and gum health',
            'Avoid biting extremely hard objects to protect the denture structure',
            'Follow your dentist’s instructions for long-term maintenance'
        ],
        faq: [{
            question: 'How are implant-supported dentures different from traditional dentures?',
            answer: 'Unlike traditional dentures that rest on the gums, implant-supported dentures are anchored to dental implants, offering more stability and comfort.'
        }, {
            question: 'Can I eat normally with implant-supported dentures?',
            answer: 'Yes! These dentures allow for better chewing and eating a wider variety of foods compared to regular dentures.'
        }, {
            question: 'How long do implant-supported dentures last?',
            answer: 'With proper care, the implants can last a lifetime, and the denture component typically lasts 10–15 years before needing replacement.'
        }, {
            question: 'Am I a candidate for implant-supported dentures?',
            answer: 'Most patients with sufficient bone volume and healthy gums are candidates. A consultation with 3D imaging will confirm your eligibility.'
        }],
        beforeandafter: [],
        testimonials: [
            'Dr. Aesha patiently explained my treatment options and answered all my questions, making me feel comfortable during  my treatment. It was the most comfortable treatment I have ever had. I am very happy with the results. Very hygienic clinic. 💯% recommended.👍 -- Nehal Patel',
            'Amazing experience with Pristine Smile, Dr Aesha has Great Hands on experience, knowledge and Apt facilities to restore your smile, pristine way. Mahi, supporting staff is also very helpful and soft spoken. Continuous chanting makes the environment divine. Highly appreciated and recommended. -- Yatin Baxi'
        ],
        relatedservices: [
            {
                detail: 'Dental Implants – Foundation for implant-supported solutions',
                link: '/implants'
            },
            {
                detail: 'Bone Grafts – Build bone structure if needed before implant placement',
                link: '/bone_grafts'
            },
            {
                detail: 'Dentures – Traditional options also available for full or partial arch replacement',
                link: '/denture'
            }
        ]
    }, bridges: {
        title: 'Dental Bridges',
        tagline: 'Close the Gap & Restore Your Smile!',
        overview: 'Dental bridges are a reliable solution for replacing one or more missing teeth. By anchoring to neighboring teeth or implants, bridges “bridge the gap” to restore proper bite alignment, prevent shifting, and bring back the look and function of your natural smile.',
        benefits: [
            '✅ Replaces one or more missing teeth with a natural appearance',
            '✅ Restores chewing function and improves speech',
            '✅ Prevents surrounding teeth from shifting out of place',
            '✅ Maintains facial structure and jaw alignment',
            '✅ Long-lasting, durable, and custom-designed for your smile'
        ],
        symptoms: [
            '✔ One or more missing teeth in a row',
            '✔ Difficulty chewing or speaking due to missing teeth',
            '✔ Noticeable gap in your smile affecting confidence',
            '✔ Teeth shifting into the space left by a missing tooth',
            '✔ Looking for a fixed alternative to removable dentures'
        ],
        treatment: [
            '1️⃣ Smile Assessment – We evaluate your oral health and take digital impressions of your teeth.',
            '2️⃣ Tooth Preparation – The supporting teeth (abutments) are reshaped to hold the bridge in place.',
            '3️⃣ Temporary Bridge – A temporary bridge is placed while your permanent one is crafted.',
            '4️⃣ Custom Fabrication – Your bridge is made to match your tooth color, shape, and bite.',
            '5️⃣ Final Placement – The permanent bridge is securely bonded and adjusted for comfort and function.'
        ],
        aftercare: [
            'Brush and floss daily, especially around the bridge area',
            'Use floss threaders or water flossers to clean under the bridge',
            'Avoid very hard or sticky foods that could damage the bridge',
            'Schedule regular dental check-ups to monitor the bridge and surrounding teeth',
            'Maintain a healthy diet to support long-term oral health'
        ],
        faq: [{
            question: 'How long does a dental bridge last?',
            answer: 'With proper care, a dental bridge can last 10–15 years or more.'
        }, {
            question: 'Is getting a bridge painful?',
            answer: 'The procedure is minimally invasive and performed under local anesthesia. Most patients report little to no discomfort.'
        }, {
            question: 'Can a bridge be supported by implants?',
            answer: 'Yes! If natural teeth aren’t suitable as anchors, we can use dental implants to support the bridge.'
        }, {
            question: 'Will a bridge look natural?',
            answer: 'Absolutely. We customize your bridge to match your natural teeth in shape, color, and size for a seamless look.'
        }],
        beforeandafter: [],
        testimonials: [
            'Dr. Aesha patiently explained my treatment options and answered all my questions, making me feel comfortable during  my treatment. It was the most comfortable treatment I have ever had. I am very happy with the results. Very hygienic clinic. 💯% recommended.👍 -- Nehal Patel',
            'Amazing experience with Pristine Smile, Dr Aesha has Great Hands on experience, knowledge and Apt facilities to restore your smile, pristine way. Mahi, supporting staff is also very helpful and soft spoken. Continuous chanting makes the environment divine. Highly appreciated and recommended. -- Yatin Baxi'
        ],
        relatedservices: [
            {
                detail: 'Crowns – Often used to support bridges on surrounding teeth',
                link: '/crowns'
            },
            {
                detail: 'Dental Implants – An alternative or support for bridge placement',
                link: '/implants'
            },
            {
                detail: 'Dentures – Another option for replacing multiple missing teeth',
                link: '/denture'
            }
        ]
    }, chipped_cracked_teeth: {
        title: 'Chipped or Cracked Teeth Repair',
        tagline: 'Restore Strength & Beauty to Damaged Teeth!',
        overview: 'Chipped or cracked teeth can happen due to injury, grinding, or biting hard foods—and if left untreated, they can lead to pain, infection, or further damage. We offer fast and effective solutions like bonding, veneers, or crowns to restore the function and appearance of your smile.',
        benefits: [
            '✅ Restores the natural shape and appearance of damaged teeth',
            '✅ Prevents further cracking, decay, or tooth loss',
            '✅ Enhances comfort and chewing ability',
            '✅ Boosts confidence with a flawless smile',
            '✅ Multiple treatment options based on the severity of damage'
        ],
        symptoms: [
            '✔ Visible chip or crack in a tooth',
            '✔ Pain when chewing or biting',
            '✔ Sensitivity to hot, cold, or sweet foods',
            '✔ Sharp edges on a tooth that irritate your tongue or cheeks',
            '✔ Discoloration or dark lines running through a tooth'
        ],
        treatment: [
            '1️⃣ Exam & Diagnosis – We evaluate the severity of the crack or chip using visual inspection and X-rays.',
            '2️⃣ Bonding – For small chips, tooth-colored resin is used to restore shape and appearance.',
            '3️⃣ Veneers – For front teeth or cosmetic concerns, thin porcelain shells are applied for a flawless finish.',
            '4️⃣ Crowns – For deeper cracks or weakened teeth, a custom crown provides strength and protection.',
            '5️⃣ Root Canal (if needed) – In cases where the crack has reached the pulp, a root canal may be necessary before restoration.'
        ],
        aftercare: [
            'Avoid chewing hard foods or objects like ice or pens',
            'Use a night guard if you grind your teeth while sleeping',
            'Practice gentle brushing with a soft-bristled toothbrush',
            'Visit your dentist regularly for check-ups and cleaning',
            'Report any sensitivity or discomfort early to prevent further issues'
        ],
        faq: [{
            question: 'Is a chipped or cracked tooth an emergency?',
            answer: 'It depends on the severity, but it’s best to have it evaluated as soon as possible to prevent complications.'
        }, {
            question: 'Will a chipped tooth grow back?',
            answer: 'No, tooth enamel doesn’t regenerate—but we can restore it with bonding, veneers, or crowns.'
        }, {
            question: 'How do I know which treatment I need?',
            answer: 'We’ll recommend the best option after examining the tooth and considering factors like location, severity, and cosmetic goals.'
        }, {
            question: 'Can I eat normally after treatment?',
            answer: 'Yes! Once the restoration is complete, your tooth will function normally again—just be cautious with very hard foods.'
        }],
        beforeandafter: [],
        testimonials: [
            'Dr. Aesha patiently explained my treatment options and answered all my questions, making me feel comfortable during  my treatment. It was the most comfortable treatment I have ever had. I am very happy with the results. Very hygienic clinic. 💯% recommended.👍 -- Nehal Patel',
            'Amazing experience with Pristine Smile, Dr Aesha has Great Hands on experience, knowledge and Apt facilities to restore your smile, pristine way. Mahi, supporting staff is also very helpful and soft spoken. Continuous chanting makes the environment divine. Highly appreciated and recommended. -- Yatin Baxi'
        ],
        relatedservices: [
            {
                detail: 'Dental Bonding – Ideal for small chips and cosmetic fixes',
                link: '/bonding'
            },
            {
                detail: 'Veneers – Great for cosmetic improvements to front teeth',
                link: '/veneers'
            },
            {
                detail: 'Crowns – Perfect for restoring strength to cracked or damaged teeth',
                link: '/crowns'
            }
        ]
    }, wisdom_tooth_pain: {
        title: 'Wisdom Tooth Evaluation & Removal',
        tagline: 'Relieve Pain & Prevent Future Problems!',
        overview: 'Wisdom teeth, also known as third molars, often erupt during late teens or early adulthood. When they grow in improperly or don’t have enough room, they can cause pain, swelling, infection, or misalignment of nearby teeth. Our team offers expert evaluation and gentle removal to relieve discomfort and protect your oral health.',
        benefits: [
            '✅ Relieves pain and pressure from impacted or misaligned wisdom teeth',
            '✅ Prevents overcrowding and damage to nearby teeth',
            '✅ Reduces risk of infection, cysts, or gum disease',
            '✅ Gentle extraction techniques with fast recovery time',
            '✅ Personalized care whether it’s one or all four wisdom teeth'
        ],
        symptoms: [
            '✔ Pain or pressure in the back of the mouth',
            '✔ Swelling or tenderness around the gums or jaw',
            '✔ Difficulty opening your mouth or chewing',
            '✔ Bad breath or unpleasant taste due to infection',
            '✔ Shifting or crowding of nearby teeth'
        ],
        treatment: [
            '1️⃣ Evaluation & X-rays – We assess the position of your wisdom teeth using panoramic imaging or 3D scans.',
            '2️⃣ Treatment Planning – We determine if extraction is needed and whether it will be simple or surgical.',
            '3️⃣ Local Anesthesia or Sedation – The area is numbed or sedation is offered for comfort during the procedure.',
            '4️⃣ Tooth Removal – The wisdom tooth is carefully extracted using minimally invasive techniques.',
            '5️⃣ Post-Op Care – We provide detailed aftercare instructions to ensure a smooth recovery.'
        ],
        aftercare: [
            'Bite gently on gauze to control bleeding',
            'Apply ice packs to reduce swelling',
            'Eat soft foods and stay hydrated during the healing period',
            'Avoid using straws, smoking, or vigorous rinsing for 24–48 hours',
            'Take prescribed medications as directed and follow all post-op guidelines'
        ],
        faq: [{
            question: 'Do all wisdom teeth need to be removed?',
            answer: 'Not always. If they’re healthy, fully erupted, and properly aligned, removal may not be necessary. We assess each case individually.'
        }, {
            question: 'Is wisdom tooth removal painful?',
            answer: 'No. The procedure is performed under local anesthesia or sedation, and post-op discomfort is usually mild and manageable.'
        }, {
            question: 'How long is recovery after wisdom tooth removal?',
            answer: 'Initial healing typically takes 3–5 days. Complete healing may take a couple of weeks depending on the complexity of the extraction.'
        }, {
            question: 'Can I go back to work or school after the procedure?',
            answer: 'You may need 1–2 days off to rest, especially if multiple teeth are removed. Most patients return to normal routines quickly.'
        }],
        beforeandafter: [],
        testimonials: [
            'Dr. Aesha patiently explained my treatment options and answered all my questions, making me feel comfortable during  my treatment. It was the most comfortable treatment I have ever had. I am very happy with the results. Very hygienic clinic. 💯% recommended.👍 -- Nehal Patel',
            'Amazing experience with Pristine Smile, Dr Aesha has Great Hands on experience, knowledge and Apt facilities to restore your smile, pristine way. Mahi, supporting staff is also very helpful and soft spoken. Continuous chanting makes the environment divine. Highly appreciated and recommended. -- Yatin Baxi'
        ],
        relatedservices: [
            {
                detail: 'Extractions – For removing problematic teeth gently and efficiently',
                link: '/extractions'
            },
            {
                detail: 'Sedation Dentistry – For a relaxed, pain-free procedure',
                link: '/sedation_dentistry'
            },
            {
                detail: 'Dental Cleanings – Maintain oral health and monitor wisdom teeth development',
                link: '/cleaning_exams'
            }
        ]
    }, missing_tooth: {
        title: 'Missing Tooth Replacement',
        tagline: 'Restore Your Smile & Oral Function!',
        overview: 'A missing tooth doesn’t just affect your smile—it can also lead to shifting teeth, bone loss, difficulty chewing, and changes in facial appearance. We offer a variety of natural-looking, long-lasting solutions including dental implants, bridges, and dentures to restore your complete smile and oral function.',
        benefits: [
            '✅ Restores your ability to chew and speak comfortably',
            '✅ Prevents surrounding teeth from shifting out of place',
            '✅ Helps maintain jawbone health and facial structure',
            '✅ Enhances confidence with a full, natural-looking smile',
            '✅ Custom solutions tailored to your needs and lifestyle'
        ],
        symptoms: [
            '✔ One or more missing teeth affecting your smile or bite',
            '✔ Difficulty chewing or speaking clearly',
            '✔ Shifting of neighboring teeth into the empty space',
            '✔ Bone loss or facial sagging after tooth loss',
            '✔ Looking for a long-term tooth replacement solution'
        ],
        treatment: [
            '1️⃣ Comprehensive Evaluation – We examine your teeth and jaw to determine the best replacement option.',
            '2️⃣ Dental Implants – A titanium post is surgically placed in the jaw to support a custom crown for a permanent solution.',
            '3️⃣ Dental Bridges – A fixed bridge uses surrounding teeth as anchors to fill the gap.',
            '4️⃣ Dentures – Removable or implant-supported dentures are used when multiple teeth are missing.',
            '5️⃣ Final Fit & Adjustments – We ensure your new tooth replacement feels natural and functions perfectly.'
        ],
        aftercare: [
            'Maintain proper brushing and flossing around your restoration',
            'Visit the dentist regularly for cleanings and exams',
            'Avoid using your replacement tooth to bite very hard objects',
            'Use a night guard if you grind your teeth',
            'Follow personalized care instructions depending on your restoration type'
        ],
        faq: [{
            question: 'What is the best way to replace a missing tooth?',
            answer: 'Dental implants are the gold standard for single-tooth replacement, but bridges and dentures are excellent alternatives depending on your case.'
        }, {
            question: 'How soon should I replace a missing tooth?',
            answer: 'It’s best to replace it as soon as possible to avoid shifting teeth, bite issues, and bone loss.'
        }, {
            question: 'Will a replacement tooth look natural?',
            answer: 'Yes! All of our replacement options are custom-designed to match your natural teeth in color, shape, and size.'
        }, {
            question: 'Are tooth replacements covered by insurance?',
            answer: 'Many insurance plans offer partial coverage for bridges and dentures. Coverage for implants may vary—our team will help you review your benefits.'
        }],
        beforeandafter: [],
        testimonials: [
            'Dr. Aesha patiently explained my treatment options and answered all my questions, making me feel comfortable during  my treatment. It was the most comfortable treatment I have ever had. I am very happy with the results. Very hygienic clinic. 💯% recommended.👍 -- Nehal Patel',
            'Amazing experience with Pristine Smile, Dr Aesha has Great Hands on experience, knowledge and Apt facilities to restore your smile, pristine way. Mahi, supporting staff is also very helpful and soft spoken. Continuous chanting makes the environment divine. Highly appreciated and recommended. -- Yatin Baxi'
        ],
        relatedservices: [
            {
                detail: 'Dental Implants – Long-term solution for single or multiple missing teeth',
                link: '/implants'
            },
            {
                detail: 'Dental Bridges – Fill the gap with a fixed, non-removable option',
                link: '/bridges'
            },
            {
                detail: 'Dentures – Full or partial replacement for multiple missing teeth',
                link: '/denture'
            }
        ]
    }, toothcare: {
        title: 'Preventive Toothcare',
        tagline: 'Protect Your Smile with Proactive Care!',
        overview: 'Toothcare is the foundation of lifelong oral health. Our preventive care services are designed to stop dental problems before they start—helping you avoid cavities, gum disease, and costly treatments. With regular check-ups, cleanings, fluoride treatments, and personalized guidance, we keep your smile strong, healthy, and shining bright.',
        benefits: [
            '✅ Prevents cavities, gum disease, and enamel erosion',
            '✅ Detects dental issues early before they worsen',
            '✅ Promotes long-term oral and overall health',
            '✅ Reduces the need for invasive or costly procedures',
            '✅ Builds healthy habits for kids and adults alike'
        ],
        symptoms: [
            '✔ Sensitivity to hot, cold, or sweet foods',
            '✔ Plaque buildup or yellowing teeth',
            '✔ Occasional bleeding while brushing or flossing',
            '✔ Irregular dental visits or missed check-ups',
            '✔ Looking to improve your daily dental hygiene routine'
        ],
        treatment: [
            '1️⃣ Comprehensive Exam – We assess your teeth, gums, and oral tissues for signs of problems.',
            '2️⃣ Professional Cleaning – Plaque and tartar are removed to prevent decay and gum disease.',
            '3️⃣ Fluoride Treatment – A fluoride application strengthens enamel and helps prevent cavities.',
            '4️⃣ Sealants (if needed) – Protective coatings applied to molars to prevent decay, especially in children.',
            '5️⃣ Personalized Oral Hygiene Plan – We provide brushing, flossing, and dietary tips tailored to your needs.'
        ],
        aftercare: [
            'Brush twice a day with fluoride toothpaste and floss daily',
            'Limit sugary snacks and acidic beverages',
            'Use a soft-bristled toothbrush and replace it every 3–4 months',
            'Drink plenty of water and rinse after meals if brushing isn’t possible',
            'Schedule check-ups every 6 months or as recommended'
        ],
        faq: [{
            question: 'How often should I visit the dentist?',
            answer: 'Most patients should visit every 6 months for exams and cleanings. Some may need more frequent visits based on individual oral health.'
        }, {
            question: 'What’s included in preventive dental care?',
            answer: 'Preventive care includes exams, cleanings, fluoride treatments, sealants, X-rays, and guidance on proper oral hygiene.'
        }, {
            question: 'Can kids and adults both benefit from toothcare services?',
            answer: 'Absolutely! Preventive care is essential at every age to build and maintain strong, healthy smiles.'
        }, {
            question: 'Do I still need dental visits if I brush and floss daily?',
            answer: 'Yes. Professional cleanings remove hardened plaque and detect early issues that at-home care can’t address.'
        }],
        beforeandafter: [],
        testimonials: [
            'Dr. Aesha patiently explained my treatment options and answered all my questions, making me feel comfortable during  my treatment. It was the most comfortable treatment I have ever had. I am very happy with the results. Very hygienic clinic. 💯% recommended.👍 -- Nehal Patel',
            'Amazing experience with Pristine Smile, Dr Aesha has Great Hands on experience, knowledge and Apt facilities to restore your smile, pristine way. Mahi, supporting staff is also very helpful and soft spoken. Continuous chanting makes the environment divine. Highly appreciated and recommended. -- Yatin Baxi'
        ],
        relatedservices: [
            {
                detail: 'Cleanings & Exams – Core part of every preventive care plan',
                link: '/cleaning_exams'
            },
            {
                detail: 'Fluoride & Sealants – Added protection for cavity-prone teeth',
                link: '/fluoride_sealants'
            },
            {
                detail: 'Family Dentistry – Preventive care for all ages in one convenient place',
                link: '/family_dentistry'
            }
        ]
    }, teeth_grinding: {
        title: 'Teeth Grinding (Bruxism) Treatment',
        tagline: 'Protect Your Smile from Nighttime Grinding!',
        overview: 'Teeth grinding, also known as bruxism, can lead to worn-down teeth, jaw pain, headaches, and even fractures. Many people grind their teeth at night without realizing it, but our customized treatment solutions—such as night guards, bite adjustments, and muscle relaxation techniques—can help protect your teeth and relieve discomfort.',
        benefits: [
            '✅ Prevents enamel wear and tooth damage',
            '✅ Reduces jaw pain, tension, and TMJ issues',
            '✅ Helps stop headaches caused by clenching',
            '✅ Protects dental work like crowns and fillings',
            '✅ Improves sleep quality and overall comfort'
        ],
        symptoms: [
            '✔ Waking up with jaw pain, soreness, or tightness',
            '✔ Frequent headaches, especially in the morning',
            '✔ Noticing worn-down or chipped teeth',
            '✔ Clicking or popping sounds in the jaw',
            '✔ Increased tooth sensitivity without decay'
        ],
        treatment: [
            '1️⃣ Consultation & Diagnosis – We assess your symptoms and examine your teeth for signs of grinding.',
            '2️⃣ Custom Night Guard – A protective oral appliance is made to cushion your teeth during sleep.',
            '3️⃣ Bite Adjustment – If needed, we adjust your bite to relieve pressure on certain teeth.',
            '4️⃣ Stress Reduction & Muscle Relaxation – We discuss techniques to reduce jaw tension, such as exercises or Botox therapy.',
            '5️⃣ Ongoing Monitoring – We track progress and make adjustments to ensure long-term relief.'
        ],
        aftercare: [
            'Wear your night guard every night for best results',
            'Avoid chewing gum or hard foods that stress the jaw',
            'Practice relaxation techniques to minimize clenching',
            'Maintain regular dental check-ups to monitor teeth and jaw health',
            'Let your dentist know if you experience continued discomfort'
        ],
        faq: [{
            question: 'What causes teeth grinding?',
            answer: 'Bruxism is often linked to stress, anxiety, misaligned teeth, or an abnormal bite. It can also be a side effect of certain medical conditions or medications.'
        }, {
            question: 'Can teeth grinding be cured?',
            answer: 'While there’s no “cure,” proper treatment like night guards, bite adjustments, and relaxation techniques can significantly reduce symptoms and prevent damage.'
        }, {
            question: 'Is a night guard comfortable to wear?',
            answer: 'Yes! Our custom night guards are designed for a snug, comfortable fit and allow easy breathing and speaking.'
        }, {
            question: 'What happens if teeth grinding is left untreated?',
            answer: 'Chronic grinding can lead to worn-down enamel, cracked teeth, TMJ disorders, and persistent jaw pain or headaches.'
        }],
        beforeandafter: [],
        testimonials: [
            'Dr. Aesha patiently explained my treatment options and answered all my questions, making me feel comfortable during  my treatment. It was the most comfortable treatment I have ever had. I am very happy with the results. Very hygienic clinic. 💯% recommended.👍 -- Nehal Patel',
            'Amazing experience with Pristine Smile, Dr Aesha has Great Hands on experience, knowledge and Apt facilities to restore your smile, pristine way. Mahi, supporting staff is also very helpful and soft spoken. Continuous chanting makes the environment divine. Highly appreciated and recommended. -- Yatin Baxi'
        ],
        relatedservices: [
            {
                detail: 'Night Guards – Custom-made for grinding protection and comfort',
                link: '/night_guard'
            },
            {
                detail: 'TMJ Therapy – Treatments to relieve jaw tension and discomfort',
                link: '/tmj_therapy'
            }
        ]
    }, stained_teeth: {
        title: 'Stained Teeth Treatment',
        tagline: 'Brighten Your Smile & Boost Your Confidence!',
        overview: 'Over time, teeth can become stained or discolored due to diet, lifestyle habits, and aging. Whether caused by coffee, tea, smoking, or natural wear, we offer professional whitening solutions and other cosmetic treatments to help you achieve a brighter, whiter smile.',
        benefits: [
            '✅ Instantly brightens your smile for a more youthful look',
            '✅ Removes stains from coffee, tea, wine, and tobacco',
            '✅ Professional treatments provide better, longer-lasting results',
            '✅ Safe and effective for all types of discoloration',
            '✅ Customizable solutions based on your goals and tooth sensitivity'
        ],
        symptoms: [
            '✔ Yellowing or darkening of teeth over time',
            '✔ Stains from coffee, tea, red wine, or tobacco',
            '✔ Uneven or blotchy tooth coloration',
            '✔ Dull or aged appearance of teeth',
            '✔ Looking to enhance smile brightness for a special occasion'
        ],
        treatment: [
            '1️⃣ Professional Whitening – We use high-strength bleaching agents for fast, dramatic results.',
            '2️⃣ Take-Home Whitening Kits – Custom trays with professional-grade whitening gel allow you to whiten on your own schedule.',
            '3️⃣ Veneers – Thin porcelain shells cover deep or resistant stains for a flawless appearance.',
            '4️⃣ Dental Bonding – A quick and effective way to improve tooth color and disguise minor discoloration.',
            '5️⃣ Preventive Care – We provide guidance on maintaining your white smile and preventing future stains.'
        ],
        aftercare: [
            'Avoid staining foods and drinks like coffee, wine, and berries',
            'Use a straw when drinking beverages that can stain teeth',
            'Brush with a whitening toothpaste to maintain results',
            'Avoid smoking or tobacco use',
            'Schedule touch-up treatments as needed'
        ],
        faq: [{
            question: 'How long do whitening results last?',
            answer: 'Results can last from several months to a few years, depending on your diet and oral hygiene habits.'
        }, {
            question: 'Is teeth whitening safe?',
            answer: 'Yes! Professional whitening treatments are safe, effective, and supervised by dental professionals to protect your enamel and gums.'
        }, {
            question: 'Can I whiten crowns or veneers?',
            answer: 'No, whitening treatments only work on natural teeth. We can discuss options to match existing dental work.'
        }, {
            question: 'Will whitening cause sensitivity?',
            answer: 'Some patients experience temporary sensitivity, but we use professional-grade products designed to minimize discomfort.'
        }],
        beforeandafter: [],
        testimonials: [
            'Dr. Aesha patiently explained my treatment options and answered all my questions, making me feel comfortable during  my treatment. It was the most comfortable treatment I have ever had. I am very happy with the results. Very hygienic clinic. 💯% recommended.👍 -- Nehal Patel',
            'Amazing experience with Pristine Smile, Dr Aesha has Great Hands on experience, knowledge and Apt facilities to restore your smile, pristine way. Mahi, supporting staff is also very helpful and soft spoken. Continuous chanting makes the environment divine. Highly appreciated and recommended. -- Yatin Baxi'
        ],
        relatedservices: [
            {
                detail: 'Teeth Whitening – In-office and take-home options available',
                link: '/teeth_whitening'
            },
            {
                detail: 'Veneers – Perfect for covering deep stains and discoloration',
                link: '/veneers'
            },
            {
                detail: 'Dental Bonding – A simple way to improve the color and appearance of teeth',
                link: '/bonding'
            }
        ]
    }, crooked_teeth: {
        title: 'Crooked Teeth Treatment',
        tagline: 'Straighten Your Smile with Confidence!',
        overview: 'Crooked teeth can affect more than just your smile’s appearance—they can also impact your bite, speech, and overall oral health. We offer advanced orthodontic solutions like Invisalign and traditional braces to help you achieve a straighter, healthier, and more confident smile.',
        benefits: [
            '✅ Enhances the appearance of your smile',
            '✅ Improves bite alignment and chewing function',
            '✅ Reduces the risk of cavities and gum disease',
            '✅ Prevents excessive wear on teeth and jaw strain',
            '✅ Customized treatment plans for all ages'
        ],
        symptoms: [
            '✔ Overlapping, crowded, or misaligned teeth',
            '✔ Difficulty chewing or speaking clearly',
            '✔ Excessive wear on certain teeth due to bite issues',
            '✔ Jaw pain or discomfort caused by misalignment',
            '✔ Wanting a straighter, more symmetrical smile'
        ],
        treatment: [
            '1️⃣ Orthodontic Evaluation – We assess your bite, tooth alignment, and overall oral health.',
            '2️⃣ Invisalign – Clear, removable aligners gently shift teeth into place over time.',
            '3️⃣ Traditional Braces – Metal or ceramic braces offer precise correction for more complex cases.',
            '4️⃣ Retainers – Used after treatment to maintain your new smile and prevent shifting.',
            '5️⃣ Cosmetic Enhancements – Bonding or veneers can help refine your smile after alignment is corrected.'
        ],
        aftercare: [
            'Wear your retainer as prescribed to maintain results',
            'Brush and floss carefully around braces or aligners',
            'Avoid sticky or hard foods that could damage orthodontic appliances',
            'Schedule regular check-ups to monitor progress and adjustments',
            'Follow all personalized care instructions for the best outcome'
        ],
        faq: [{
            question: 'What’s the best way to fix crooked teeth?',
            answer: 'Invisalign and braces are the most effective ways to straighten teeth, but bonding or veneers may be options for minor cosmetic fixes.'
        }, {
            question: 'How long does orthodontic treatment take?',
            answer: 'The timeline varies depending on severity, but most treatments last between 6 months to 2 years.'
        }, {
            question: 'Are clear aligners as effective as braces?',
            answer: 'Yes! Invisalign can treat most cases of misalignment, but traditional braces may be recommended for complex corrections.'
        }, {
            question: 'Can crooked teeth cause health issues?',
            answer: 'Yes, misaligned teeth can contribute to jaw pain, excessive tooth wear, gum disease, and difficulty cleaning between teeth.'
        }],
        beforeandafter: [],
        testimonials: [
            'Dr. Aesha patiently explained my treatment options and answered all my questions, making me feel comfortable during  my treatment. It was the most comfortable treatment I have ever had. I am very happy with the results. Very hygienic clinic. 💯% recommended.👍 -- Nehal Patel',
            'Amazing experience with Pristine Smile, Dr Aesha has Great Hands on experience, knowledge and Apt facilities to restore your smile, pristine way. Mahi, supporting staff is also very helpful and soft spoken. Continuous chanting makes the environment divine. Highly appreciated and recommended. -- Yatin Baxi'
        ],
        relatedservices: [
            {
                detail: 'Invisalign – Discreet, clear aligners for straightening teeth',
                link: '/invisalign'
            },
            {
                detail: 'Traditional Braces – Reliable orthodontic treatment for all ages',
                link: '/traditional_braces'
            },
            {
                detail: 'Smile Makeover – A complete transformation combining multiple treatments',
                link: '/smile_makeover'
            }
        ]
    }, bleeding_gums: {
        title: 'Bleeding Gums Treatment',
        tagline: 'Protect Your Gums, Preserve Your Smile!',
        overview: 'Bleeding gums are often an early sign of gum disease and should not be ignored. Whether caused by poor oral hygiene, plaque buildup, or an underlying condition, our gum therapy treatments help restore gum health, prevent infection, and protect your teeth from long-term damage.',
        benefits: [
            '✅ Stops gum bleeding and inflammation',
            '✅ Reduces the risk of gum disease and tooth loss',
            '✅ Removes plaque and tartar buildup that irritates gums',
            '✅ Strengthens gums and improves overall oral health',
            '✅ Prevents bad breath caused by bacterial infection'
        ],
        symptoms: [
            '✔ Gums that bleed when brushing or flossing',
            '✔ Red, swollen, or tender gums',
            '✔ Persistent bad breath or a bad taste in the mouth',
            '✔ Receding gums or teeth appearing longer',
            '✔ Loose teeth or gum sensitivity'
        ],
        treatment: [
            '1️⃣ Gum Evaluation – We examine your gums and measure pocket depth to assess gum health.',
            '2️⃣ Deep Cleaning (Scaling & Root Planing) – Removes plaque and tartar buildup below the gumline.',
            '3️⃣ Antibacterial Rinse – We may prescribe special rinses to help reduce bacteria and inflammation.',
            '4️⃣ Laser Gum Therapy (if needed) – Advanced laser treatment to disinfect and promote gum healing.',
            '5️⃣ Ongoing Maintenance – Follow-up care and at-home hygiene instructions to prevent recurrence.'
        ],
        aftercare: [
            'Brush gently with a soft-bristled toothbrush twice daily',
            'Floss daily to remove plaque from between teeth and gums',
            'Use an antibacterial mouthwash as recommended',
            'Maintain a balanced diet and stay hydrated to support gum health',
            'Visit your dentist regularly for professional cleanings and check-ups'
        ],
        faq: [{
            question: 'Why do my gums bleed when I brush or floss?',
            answer: 'Bleeding gums are usually a sign of gum inflammation caused by plaque buildup. It can also be due to aggressive brushing or flossing.'
        }, {
            question: 'Is bleeding gums a sign of gum disease?',
            answer: 'Yes, early-stage gum disease (gingivitis) often causes bleeding gums. If untreated, it can progress to periodontitis, leading to tooth loss.'
        }, {
            question: 'Can bleeding gums be reversed?',
            answer: 'Yes! With proper oral hygiene and professional gum therapy, gingivitis can be reversed before it worsens.'
        }, {
            question: 'Should I stop flossing if my gums bleed?',
            answer: 'No. Keep flossing gently to remove plaque buildup. Over time, your gums will become healthier and bleed less.'
        }],
        beforeandafter: [],
        testimonials: [
            'Dr. Aesha patiently explained my treatment options and answered all my questions, making me feel comfortable during  my treatment. It was the most comfortable treatment I have ever had. I am very happy with the results. Very hygienic clinic. 💯% recommended.👍 -- Nehal Patel',
            'Amazing experience with Pristine Smile, Dr Aesha has Great Hands on experience, knowledge and Apt facilities to restore your smile, pristine way. Mahi, supporting staff is also very helpful and soft spoken. Continuous chanting makes the environment divine. Highly appreciated and recommended. -- Yatin Baxi'
        ],
        relatedservices: [
            {
                detail: 'Gum Therapy – Deep cleaning and laser treatment for healthier gums',
                link: '/gum_therapy'
            },
            {
                detail: 'Dental Cleanings – Routine cleanings to prevent gum disease',
                link: '/cleaning_exams'
            },
            {
                detail: 'Bad Breath Treatment – Addressing gum-related causes of bad breath',
                link: '/bad_breath'
            }
        ]
    }, bad_breath: {
        title: 'Bad Breath Treatment',
        tagline: 'Fresh Breath, Healthy Smile!',
        overview: 'Chronic bad breath (halitosis) can be embarrassing and is often a sign of underlying dental or medical issues. Our comprehensive bad breath treatment addresses the root cause—whether it’s plaque buildup, gum disease, or dry mouth—helping you achieve long-lasting freshness and confidence.',
        benefits: [
            '✅ Eliminates persistent bad breath and unpleasant taste',
            '✅ Removes odor-causing bacteria and plaque buildup',
            '✅ Treats underlying causes like gum disease and dry mouth',
            '✅ Boosts confidence in social and professional settings',
            '✅ Provides long-term oral hygiene solutions'
        ],
        symptoms: [
            '✔ Constant bad breath despite regular brushing',
            '✔ Dry mouth or thick saliva',
            '✔ White or coated tongue',
            '✔ Unpleasant taste in the mouth',
            '✔ Bleeding gums or signs of gum disease'
        ],
        treatment: [
            '1️⃣ Oral Exam & Breath Analysis – We evaluate your mouth, gums, and tongue for signs of bacterial buildup.',
            '2️⃣ Professional Cleaning – Plaque and tartar are removed to eliminate odor-causing bacteria.',
            '3️⃣ Gum Disease Treatment (if needed) – Deep cleaning or gum therapy to treat infections linked to bad breath.',
            '4️⃣ Tongue Cleaning & Antibacterial Rinses – Special rinses and tongue scraping techniques to remove bacteria.',
            '5️⃣ Lifestyle & Dietary Guidance – Personalized recommendations for hydration, nutrition, and daily hygiene habits.'
        ],
        aftercare: [
            'Brush and floss daily to remove food particles and plaque',
            'Clean your tongue using a tongue scraper or brush',
            'Stay hydrated and avoid excessive alcohol or caffeine intake',
            'Use antibacterial mouthwash as recommended',
            'Schedule regular dental check-ups for ongoing breath management'
        ],
        faq: [{
            question: 'What causes bad breath?',
            answer: 'Common causes include poor oral hygiene, gum disease, dry mouth, smoking, and certain foods like garlic and onions.'
        }, {
            question: 'Can bad breath be a sign of a bigger health problem?',
            answer: 'Yes, persistent bad breath can be linked to gum disease, infections, acid reflux, or even medical conditions like diabetes.'
        }, {
            question: 'Does mouthwash cure bad breath?',
            answer: 'Mouthwash can temporarily mask odors, but treating the underlying cause is the only way to achieve lasting freshness.'
        }, {
            question: 'How can I prevent bad breath long-term?',
            answer: 'Good oral hygiene, regular dental cleanings, staying hydrated, and treating any underlying dental issues will keep your breath fresh.'
        }],
        beforeandafter: [],
        testimonials: [
            'Dr. Aesha patiently explained my treatment options and answered all my questions, making me feel comfortable during  my treatment. It was the most comfortable treatment I have ever had. I am very happy with the results. Very hygienic clinic. 💯% recommended.👍 -- Nehal Patel',
            'Amazing experience with Pristine Smile, Dr Aesha has Great Hands on experience, knowledge and Apt facilities to restore your smile, pristine way. Mahi, supporting staff is also very helpful and soft spoken. Continuous chanting makes the environment divine. Highly appreciated and recommended. -- Yatin Baxi'
        ],
        relatedservices: [
            {
                detail: 'Dental Cleanings – Routine cleanings to remove plaque and bacteria',
                link: '/cleaning_exams'
            },
            {
                detail: 'Gum Therapy – Treat gum disease, a common cause of bad breath',
                link: '/gum_therapy'
            },
            {
                detail: 'Preventive Toothcare – Personalized hygiene plans to maintain fresh breath',
                link: '/toothcare'
            }
        ]
    }
}